"use client"

// src/pages/SolicitudAdquisiciones.jsx
import { useEffect, useMemo, useState, useRef } from "react"
import { v4 as uuidv4 } from "uuid"

import {
  Document,
  Packer,
  Paragraph,
  AlignmentType,
  Table,
  TableRow,
  TableCell,
  WidthType,
  BorderStyle,
  TextRun,
  ImageRun,
  VerticalAlign,
} from "docx"
import html2pdf from "html2pdf.js"

import logo from "../assets/DesarrollandoTerritorios.png"

const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || window.location.origin;

const logoHeader = logo



/** ====== CONSTANTES ====== */
const MAX_1K = 1000,
  MAX_2K = 2000,
  MAX_5K = 5000,
  MAX_8K = 8000,
  MAX_10K = 10000
const BLUE = "1F4E8C",
  BLUE_SOFT = "EAF1FB",
  GRAY_BORDER = "D8DFEA"
const CURRENCY = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  maximumFractionDigits: 0,
})
const opcionesProgramas = [
  { value: "", label: "Seleccionar..." },
  {
    value: "1.1.1",
    label:
      "1.1.1 Fortalecimiento de los servicios de salud hacia la descentralizacion, la ampliacion de la cobertura. ",
  },
  { value: "1.1.2", label: "1.1.2 Vida Saludable en Copacabana. " },
  { value: "1.1.3", label: "1.1.3 Infraestructura innovadora y con calidad. " },
  { value: "1.1.4", label: "1.1.4  Fortalecimiento de los niveles de gobernanza de la salud.  " },
  { value: "1.2.1", label: "1.2.1 Fortalecimiento integral, pedagógico y educativo. " },
  { value: "1.2.2", label: "1.2.2 Acceso y permanencia en sistema educativo desde un enfoque territorial. " },
  {
    value: "1.2.3",
    label:
      "1.2.3 Desarrollo de un ecosistema  educativo 4.0 que apunte al fortalecimiento y encadenamineto de los diferentes niveles educativos. ",
  },
  { value: "1.3.1", label: "1.3.1 La cultura como vocación para el desarrollo en Copacabana. " },
  { value: "1.3.2", label: "1.3.2 Gestión, protección y salvaguardia del patrimonio cultural. " },
  { value: "1.3.3", label: "1.3.3 Mejoramiento y dotación de la infraestructura cultural.  " },
  { value: "1.3.4", label: "1.3.4 Gobernaza para la inclusión cultural. " },
  {
    value: "1.4.1",
    label:
      "1.4.1 Fortalecimiento de la cultura deportiva para el fomento a la recreación, la actividad física y el deporte. ",
  },
  {
    value: "1.4.2",
    label:
      "1.4.2 Fortalecimiento de la práctica deportiva, la infraestructura, la formación y preparación de deportistas aficionados y de alto rendimiento. ",
  },
  { value: "1.4.3", label: "1.4.3 Liderazgo en gobernanza para la gestión deportiva. " },
  {
    value: "2.1.1",
    label:
      "2.1.1 Protección, conservación y restauración de los sistemas naturales a través del SILAP y sus servicios ecosistemicos. ",
  },
  { value: "2.1.2", label: "2.1.2 Gestión Sostenible del Agua. " },
  { value: "2.1.3", label: "2.1.3 Adaptación al cambio climático. " },
  { value: "2.1.4", label: "2.1.4 Educación y cultura ambiental territorializada. " },
  { value: "2.1.5", label: "2.1.5 Gestión de residuos y fortalecimiento ambiental. " },
  { value: "2.1.6", label: "2.1.6 Producción verde y responsable. " },
  { value: "2.2.1", label: "2.2.1 Bienestar animal y tenencia responsable. " },
  { value: "2.3.1", label: "2.3.1 Hacia un gestión del riesgo integral. " },
  { value: "2.3.2", label: "2.3.2 Planificación e implementación técnica y normativa para el control del riesgo. " },
  {
    value: "2.3.3",
    label:
      "2.3.3 Capacidades técnicas y tecnológica para las medidas de prevención y mitigación de la gestión del riesgo. ",
  },
  { value: "2.4.1", label: "2.4.1 Vivienda digna para sus habitantes y servicios públicos. " },
  {
    value: "2.5.1",
    label: "2.5.1 Fortalecimiento de la Movilidad en Copacabana sostenible y con enfoque diferencial. ",
  },
  { value: "2.5.2", label: "2.5.2 Mejora de la Infraestructura Vial. " },
  { value: "2.5.3", label: "2.5.3 Movilidad innovadora e  inteligente. " },
  { value: "2.6.1", label: "2.6.1 Actualización del Plan Básico de Ordenamineto Territorial. " },
  { value: "2.6.2", label: "2.6.2 Ordenamiento territorial, infraestructura y desarrollo urbano. " },
  { value: "3.1.1", label: "3.1.1 Hacia una cultura del emprendimiento y el desarrollo empresarial. " },
  {
    value: "3.1.2",
    label: "3.1.2 Emprendimiento como alternativa para la generación y formalización para  empleo. ",
  },
  { value: "3.1.3", label: "3.1.3 Fortalecimiento empresarial desde un enfoque de  valor agregado. " },
  {
    value: "3.1.4",
    label: "3.1.4 Fortalecimiento del ecosistema empresarial y de innovación con enfoque metropolitano. ",
  },
  { value: "3.1.5", label: "3.1.5 Promoción del empleo y el trabajo. " },
  { value: "3.2.1", label: "3.2.1 Desarrollo agropecuario sostenible. " },
  { value: "3.2.2", label: "3.2.2 Desarrollo de cadenas de valor y promoción de productos locales. " },
  { value: "3.3.1", label: "3.3.1 Actualización del Plan de Desarrollo Turístico sostenible. " },
  {
    value: "3.3.2",
    label:
      "3.3.2 Gestión integral del ecosistema turistico y el fortalecimiento de la promoción y el mercadeo, para el mejoramiento de la competitividad turística. ",
  },
  { value: "3.3.3", label: "3.3.3 Fortalecimiento de la Infraestructura Turística. " },
  {
    value: "3.4.1",
    label:
      "3.4.1 Desarrollo empresarial de base tecnológica y su integración al distrito de CTeI Regional Metropolitano. ",
  },
  {
    value: "3.4.2",
    label: "3.4.2 Fortalecimiento de las capacidades digitales y la adopción de nuevas tecnologías 4.0. ",
  },
  { value: "3.4.3", label: "3.4.3 Fortalecimiento de la Infraestructura Tecnológica para la competitividad. " },
  { value: "3.4.4", label: "3.4.4 Hacia un territorio inteligente. " },
  { value: "4.1.1", label: "4.1.1 Desarrollo integral de la primera infancia. " },
  {
    value: "4.1.2",
    label: "4.1.2 Fortalecimiento de la infraestructura para el desarrollo integral de la primera infancia. ",
  },
  { value: "4.10.1", label: "4.10.1 Fortalecimiento integral de las víctimas del conflicto. " },
  {
    value: "4.11.1",
    label:
      "4.11.1 Programa integral de seguridad  e instrumentos de planificación y gestión como el plan de seguridad. ",
  },
  {
    value: "4.11.2",
    label:
      "4.11.2 Reconstrucción del Tejido Social a través del Arte y el Deporte para la convivencia en copacabana. ",
  },
  {
    value: "4.11.3",
    label: "4.11.3 Implementar soluciones comunitarias y tecnológicas para la prevención del delito. ",
  },
  {
    value: "4.2.1",
    label: "4.2.1 Desarrollo integral, las capacidades especiales y los talentos excepcionales de la niñez. ",
  },
  { value: "4.3.1", label: "4.3.1 Fortalecimiento y protección integral del adulto mayor. " },
  { value: "4.4.1", label: "4.4.1 Fortalecimiento integral de la juventud. " },
  { value: "4.5.1", label: "4.5.1 Desarrollo integral de las mujeres. " },
  { value: "4.6.1", label: "4.6.1 Fortalecimiento  integral de de la población LGTIQA+. " },
  { value: "4.7.1", label: "4.7.1 Fortalecimiento  integral de de la población en condición de discapacidad. " },
  { value: "4.8.1", label: "4.8.1 Fortalecimiento y atención   integral de de la población habitante de calle. " },
  { value: "4.9.1", label: "4.9.1 Inclusión del sector religioso y fortalecimiento del culto religioso. " },
  {
    value: "5.1.1",
    label:
      "5.1.1 Fortalecimiento de la hacienda publica municpal y la  gestión de recursos para el municipio de copacabana. ",
  },
  {
    value: "5.1.2",
    label:
      "5.1.2 Modernización institucional y de instrumentos técnicos y tecnológicos para mejorar la prestación de los servicios de manera cercana para los ciudadanos de copacabana. ",
  },
  {
    value: "5.2.1",
    label:
      "5.2.1 Fortalecimiento de la participación y la gestión pública para el desarrollo de procesos de articulación y transparencia en torno a la legitimidad y confianza comunitaria en la administración de Copacabana. ",
  },
  {
    value: "5.3.1",
    label:
      "5.3.1 Fortalecimiento integral del bienestar del personal articulada a la gestión pública en copacabana. ",
  },
]
const opcionesIndicadores = [
  { value: "", label: "Seleccionar..." },
  {
    value: "1.1.1.1",
    label:
      '1.1.1.1 Campañas de Salud en Zonas descentralizadas, en el marco de "Salud en mi barrio y mi vereda", realizadas. ',
  },
  {
    value: "1.1.1.2",
    label:
      "1.1.1.2 Cobertura de servicios de primer nivel de complejidad para la Población No Asegurada - PNA que demanda la atención. ",
  },
  { value: "1.1.1.3", label: "1.1.1.3 Cobertura del aseguramiento en salud del Régimen Subsidiado. " },
  {
    value: "1.1.1.4",
    label:
      "1.1.1.4 Acciones para impactar la cobertura en salud de los habitantes, realizando depuración de base de datos, encuestas Sisbén, afiliaciones al régimen subsidiado, afiliaciones a través del SAT, afiliaciones institucionales, seguimiento a recién nacidos y gestión PNA. ",
  },
  {
    value: "1.1.2.1",
    label:
      "1.1.2.1 Acciones como jornadas para la prevención, rutas de intervención, acompañamiento familiar y campañas de divulgación y formación en temas de consumo de sustancias psicoactivas implementadas. ",
  },
  { value: "1.1.2.2", label: "1.1.2.2 Víctimas de violencias sexuales identificadas, con atención integral. " },
  { value: "1.1.2.3", label: "1.1.2.3 Campañas en temas de salud sexual y reproductiva implementadas. " },
  {
    value: "1.1.2.4",
    label:
      "1.1.2.4 Difusiones de la situación de salud realizadas en las comunidades organizadas, mediante boletines epidemiológicos que serán compartidos por las redes sociales de la alcaldía municipal. ",
  },
  {
    value: "1.1.2.5",
    label:
      "1.1.2.5 Acciones de educación a través de campañas educativas, capacitaciones y acompañamientos para la salud oral realizadas. ",
  },
  { value: "1.1.2.6", label: "1.1.2.6 Visitas a establecimientos de interés sanitario realizadas. " },
  {
    value: "1.1.2.7",
    label:
      "1.1.2.7 Cumplimiento del Plan de Intervenciones Colectivas bajo la estrategia Atención Primaria en Salud. ",
  },
  {
    value: "1.1.2.8",
    label:
      "1.1.2.8 Campañas de detección temprana, de educación en salud y orientación para la promoción y prevención de condiciones crónicas prevalentes realizadas. ",
  },
  {
    value: "1.1.2.9",
    label:
      "1.1.2.9 Campañas para abordar situaciones de salud relacionadas con condiciones ambientales implementadas. ",
  },
  { value: "1.1.2.10", label: "1.1.2.10 Vacunas contra la rabia para perros y gatos aplicadas en el municipio. " },
  {
    value: "1.1.2.11",
    label: "1.1.2.11 Personas beneficiadas en las acciones para la prevención y atención de alteraciones visuales. ",
  },
  {
    value: "1.1.2.12",
    label: "1.1.2.12 Campañas para abordar situaciones prevalentes de origen laboral implementadas. ",
  },
  {
    value: "1.1.2.13",
    label:
      "1.1.2.13 Sesiones grupales de apoyo psicosocial para el trámite de experiencias asociadas con la conducta suicida realizados. ",
  },
  {
    value: "1.1.2.14",
    label:
      "1.1.2.14 Sesiones de capacitación sobre el reconocimiento de las habilidades para la vida dirigida a la comunidad en general realizadas. ",
  },
  {
    value: "1.1.2.15",
    label:
      "1.1.2.15 Acciones de salud pública como campañas, jornadas de concientización y capacitaciones  realizadas para el autocuidado y la promoción de hábitos de vida saludable con la comunidad en general. ",
  },
  { value: "1.1.2.16", label: "1.1.2.16 Encuentros y capacitaciones sobre salud mental realizados. " },
  {
    value: "1.1.2.17",
    label: "1.1.2.17 Índice de Riesgo de la Calidad del Agua - IRCA para consumo humano – municipal. ",
  },
  {
    value: "1.1.2.18",
    label: "1.1.2.18 Acciones en salud mental y hábitos de vida sanos dirigidas a los grupos de adulto mayor. ",
  },
  {
    value: "1.1.2.19",
    label:
      "1.1.2.19 Acciones como capacitaciones, acompañamientos a grupos poblacionales, divulgación y promoción en medios de comunicación, entre otros, en salud mental y hábitos de vida sanos dirigidas a las instituciones educativas. ",
  },
  {
    value: "1.1.2.20",
    label: "1.1.2.20 Personas beneficiadas con la estrategia Te escuchamos: Copacabana como un entorno protector. ",
  },
  {
    value: "1.1.3.1",
    label:
      "1.1.3.1 Transferencia para el fortalecimiento de la Red Pública de servicios de salud de la ESE Hospital Santa Margarita de Copacabana realizada por la Secretaría de Salud. ",
  },
  { value: "1.1.4.1", label: "1.1.4.1 Ejecución de los recursos del Fondo Local de Salud. " },
  {
    value: "1.1.4.2",
    label:
      "1.1.4.2 Satisfacción de los usuarios que acceden a los servicios de salud en la red prestadora del municipio. ",
  },
  {
    value: "1.1.4.3",
    label: "1.1.4.3 PQRSD relacionadas a Inspección, Vigilancia y Control Sanitario (IVC) atendidas. ",
  },
  { value: "1.1.4.4", label: "1.1.4.4 Cumplimiento en la capacidad de gestión en salud. " },
  {
    value: "1.1.4.5",
    label: "1.1.4.5 Cumplimiento del Plan de Acción de la Política Pública de Participación Social en Salud. ",
  },
  {
    value: "1.2.1.1",
    label:
      "1.2.1.1 Espacios para Aprender: Infraestructura educativa mejorada para la Innovación y Calidad Educativa. ",
  },
  {
    value: "1.2.1.2",
    label: "1.2.1.2 Sedes Educativas dotadas con mobiliario para un entorno de aprendizaje adecuado y funcional. ",
  },
  { value: "1.2.1.3", label: "1.2.1.3 Estrategia de tránsito armónico actualizada e implementada. " },
  {
    value: "1.2.1.4",
    label:
      "1.2.1.4 Estudiantes en proceso de transición, beneficiados con la estrategia de tránsito armónico en primera infancia. ",
  },
  {
    value: "1.2.1.5",
    label: "1.2.1.5 Personas beneficiadas con la estrategia Educación sin barreras: Unidad de Atención Integral. ",
  },
  {
    value: "1.2.1.6",
    label:
      "1.2.1.6 Estrategia 'Educación sin barreras' para la atención integral de estudiantes en situación de discapacidad, creada e implementada. ",
  },
  {
    value: "1.2.1.7",
    label: "1.2.1.7 Número de estudiantes beneficiados con el Programa de Alimentación Escolar (PAE) implementado. ",
  },
  {
    value: "1.2.1.8",
    label:
      "1.2.1.8 Estrategia formulada e implementada del Consultorio Educativo para el fortalecimiento académico de estudiantes de las EE. ",
  },
  { value: "1.2.1.9", label: "1.2.1.9 Estudiantes beneficiados por la estrategia del Consultorio Educativo. " },
  {
    value: "1.2.1.10",
    label:
      "1.2.1.10 Estudiantes beneficiados con tiquetes urbanos y rurales entregados para los estudiantes del municipio. ",
  },
  { value: "1.2.2.1", label: "1.2.2.1 Formulación, aprobación y socialización del Plan Educativo Municipal. " },
  {
    value: "1.2.2.2",
    label: "1.2.2.2 Foros de educación como escenarios de participación, diálogo y reflexión implementados. ",
  },
  { value: "1.2.2.3", label: "1.2.2.3 Estrategias de Bilingüismo implementadas. " },
  { value: "1.2.2.4", label: "1.2.2.4 Personas beneficiadas con estrategias de promoción del bilingüismo. " },
  { value: "1.2.2.5", label: "1.2.2.5 Cátedra municipal de Historia Local creada e implementada. " },
  { value: "1.2.2.6", label: "1.2.2.6 Sedes educativas con la cátedra municipal de Historia Local Implementada. " },
  {
    value: "1.2.2.7",
    label: "1.2.2.7 Programa de estímulos para la permanencia y calidad educativa creado y ejecutado. ",
  },
  {
    value: "1.2.2.8",
    label:
      "1.2.2.8 Jornadas de estímulos en el marco del programa de estímulos para la permanencia y calidad educativa. ",
  },
  {
    value: "1.2.2.9",
    label:
      "1.2.2.9 Docentes de las instituciones educativas oficiales capacitados en ámbitos técnicos, tecnológicos y de actualización académica/metodológica. ",
  },
  {
    value: "1.2.2.10",
    label:
      "1.2.2.10 Estrategia de reconocimiento y fortalecimiento de prácticas educativas innovadoras creado e implementado. ",
  },
  {
    value: "1.2.2.11",
    label:
      "1.2.2.11 Estrategia de bienestar para la comunidad educativa creada e implementada (físico, emocional y social). ",
  },
  {
    value: "1.2.2.12",
    label:
      "1.2.2.12 Docentes de las instituciones educativas oficiales beneficiados por la estrategia de bienestar docente. ",
  },
  {
    value: "1.2.2.13",
    label:
      "1.2.2.13 Establecimientos educativos articulados a los programas y estrategias de la administración municipal. ",
  },
  {
    value: "1.2.2.14",
    label:
      "1.2.2.14 Programas y estrategias de la administración en el marco de la articulación con las instituciones educativas. ",
  },
  {
    value: "1.2.2.15",
    label: "1.2.2.15 Procesos de articulación entre primera infancia y el sector educativo oficial implementados. ",
  },
  {
    value: "1.2.2.16",
    label:
      "1.2.2.16 Personas impactadas en los procesos de articulación entre primera infancia y el sector educativo oficial. ",
  },
  {
    value: "1.2.2.17",
    label:
      "1.2.2.17 Personas beneficiadas con estrategias de educación para el acceso a la educación técnica, tecnológica y profesional. ",
  },
  { value: "1.2.2.18", label: "1.2.2.18 Fondo de educación superior creado. " },
  { value: "1.2.2.19", label: "1.2.2.19 Puntaje promedio en Pruebas Saber. " },
  {
    value: "1.2.2.20",
    label:
      "1.2.2.20 Estudiantes de último grado de establecimientos públicos beneficiados con programas de preuniversitario y preicfes como fortalecimiento al acceso de la educación superior. ",
  },
  {
    value: "1.2.2.21",
    label:
      "1.2.2.21 Beneficiarios de estrategias o programas de fomento para el acceso a la educación superior o terciaria. ",
  },
  {
    value: "1.2.2.22",
    label:
      "1.2.2.22 Programa de Orientación Vocacional, intereses y motivaciones para el proyecto de vida de los estudiantes de las instituciones educativas oficiales, creado e implementado. ",
  },
  {
    value: "1.2.2.23",
    label:
      "1.2.2.23 Estudiantes de media académica beneficiados con el programa de orientación vocacional, intereses y motivaciones para el proyecto de vida. ",
  },
  {
    value: "1.2.3.1",
    label:
      "1.2.3.1 Acciones como capacitaciones, asesorías a instituciones educativas oficiales, integración a PEI, acompañamientos a docentes, directivos docentes y estudiantes para el fortalecimiento del Ecosistema educativo 4.0. ",
  },
  { value: "1.2.3.2", label: "1.2.3.2 Estrategia del Ecosistema Educativo 4.0 creada e implementada. " },
  {
    value: "1.2.3.3",
    label:
      "1.2.3.3 Programa STEAM: habilidades en ciencia, tecnología, educación, arte y matemáticas, creado e implementado. ",
  },
  { value: "1.2.3.4", label: "1.2.3.4 Estudiantes beneficiados por el programa STEAM Copacabana. " },
  { value: "1.2.3.5", label: "1.2.3.5 Estrategia Educación con vos creada e implementada. " },
  { value: "1.2.3.6", label: "1.2.3.6 Personas beneficiadas con la estrategia: Educación con Vos. " },
  { value: "1.2.3.7", label: "1.2.3.7 Estrategia de 'Cero anafabetismo' actualizada e implementada. " },
  { value: "1.2.3.8", label: "1.2.3.8 Personas beneficiadas con la estrategia de alfabetización. " },
  { value: "1.2.3.9", label: "1.2.3.9 Estrategia 'El Alcalde en Tu Colegio' creada e implementada. " },
  {
    value: "1.2.3.10",
    label:
      "1.2.3.10 Visitas a las instituciones educativas desde la estrategia 'El Alcalde en Tu Colegio' realizadas. ",
  },
  {
    value: "1.3.1.1",
    label: "1.3.1.1 Plan de estímulos, becas y reconocimientos para los artistas locales implementado. ",
  },
  { value: "1.3.1.2", label: "1.3.1.2 Capacitaciones técnicas sobre normativas y proyectos anualmente. " },
  { value: "1.3.1.3", label: "1.3.1.3 Estrategia del nodo de economía cultural y creativa gestionado. " },
  {
    value: "1.3.1.4",
    label: "1.3.1.4 Estrategia InnovArte para Impulso a la Economía Creativa de Copacabana implementada. ",
  },
  { value: "1.3.1.5", label: "1.3.1.5 Sistema de circulación artístico y cultural implementado. " },
  {
    value: "1.3.1.6",
    label: "1.3.1.6 Programa de desarrollo de habilidades artísticas para la profesionalización. ",
  },
  {
    value: "1.3.2.1",
    label:
      "1.3.2.1 Acciones de divulgación e intervención para gestión, protección y salvaguardia del patrimonio cultural realizadas. ",
  },
  {
    value: "1.3.2.2",
    label:
      "1.3.2.2 Estrategia 'Copacabana es mi pueblo', como estrategia de preservación, conservación y divulgación del patrimonio cultural, implementada. ",
  },
  { value: "1.3.2.3", label: "1.3.2.3 Escuela de vigías del patrimonio cultural creada. " },
  { value: "1.3.2.4", label: "1.3.2.4 Inventario del Patrimonio material e inmaterial realizado. " },
  { value: "1.3.2.5", label: "1.3.2.5 Planes de manejo Arqueológico realizados. " },
  { value: "1.3.2.6", label: "1.3.2.6 Planes Especiales de Manejo y Protección implementados. " },
  { value: "1.3.2.7", label: "1.3.2.7 Plan Especial de Salvaguardia implementado. " },
  {
    value: "1.3.2.8",
    label:
      "1.3.2.8 Estrategia de recuperación e integración de caminos ancestrales, en alianza entre la secretaría de medio ambiente y agricultura con la secretaría de educación y cultura, implementada. ",
  },
  { value: "1.3.3.1", label: "1.3.3.1 Espacios descentralizados para la cultura dotados. " },
  { value: "1.3.3.2", label: "1.3.3.2 Espacios de divulgación e integración cultural fortalecidos y creados. " },
  { value: "1.3.3.3", label: "1.3.3.3 Red municipal de bibliotecas en barrios y veredas creada y fortalecida. " },
  { value: "1.3.3.4", label: "1.3.3.4 Nuevas colecciones adquiridas para la red municipal de bibliotecas. " },
  { value: "1.3.3.5", label: "1.3.3.5 Espacios con Sentido: infraestructura cultural mejorada. " },
  { value: "1.3.3.6", label: "1.3.3.6 Espacios con Sentido: infraestructura cultural construida. " },
  {
    value: "1.3.4.1",
    label:
      "1.3.4.1 Programas de formación y educación cultural, inclusivos, en la Casa de la Cultura implementados. ",
  },
  {
    value: "1.3.4.2",
    label:
      "1.3.4.2 Programas del sector cultural del municipio orientados al acceso y la participación activa de la comunidad fortalecidos. ",
  },
  { value: "1.3.4.3", label: "1.3.4.3 Población en procesos artísticos y culturales formadas anualmente. " },
  {
    value: "1.3.4.4",
    label:
      "1.3.4.4 Plan decenal de Cultura como una herramienta estratégica para la articulación y orientación de las políticas culturales elaborado. ",
  },
  { value: "1.3.4.5", label: "1.3.4.5 Zonas del municipio participantes de la red municipal de bibliotecas. " },
  { value: "1.3.4.6", label: "1.3.4.6 Personas que participan de la red municipal de bibliotecas. " },
  { value: "1.3.4.7", label: "1.3.4.7 Consejo Municipal de Cultura fortalecido. " },
  { value: "1.3.4.8", label: "1.3.4.8 Alianzas para la gestión cultural realizadas. " },
  {
    value: "1.3.4.9",
    label: "1.3.4.9 Intervenciones para apoyar y fortalecer los espacios de participación ciudadana. ",
  },
  { value: "1.3.4.10", label: "1.3.4.10 Sistema municipal de información artística y cultural fortalecido. " },
  { value: "1.3.4.11", label: "1.3.4.11 Festivales y ferias artísticas y culturales realizadas. " },
  {
    value: "1.4.1.1",
    label: "1.4.1.1 Personas que acceden a servicios deportivos, recreativos y de actividad física. ",
  },
  { value: "1.4.1.2", label: "1.4.1.2 Deportes, incluyendo alternativos o no convencionales, ofertados. " },
  { value: "1.4.1.3", label: "1.4.1.3 Niños, niñas, adolescentes y jóvenes inscritos en Escuelas Deportivas. " },
  { value: "1.4.1.4", label: "1.4.1.4 Niños, niñas, adolescentes y jóvenes con talento deportivo incentivados. " },
  {
    value: "1.4.1.5",
    label:
      "1.4.1.5 Jornadas deportivas institucionales de juegos escolares, intercolegiados, departamentales y nacionales. ",
  },
  {
    value: "1.4.1.6",
    label:
      "1.4.1.6 Número de deportistas participantes en juegos escolares, intercolegiados, departamentales y nacionales. ",
  },
  {
    value: "1.4.1.7",
    label:
      "1.4.1.7 Creación de la estrategia “Noches comunitarias” como espacios de descentralización, diversión y esparcimiento para los habitantes. ",
  },
  { value: "1.4.1.8", label: "1.4.1.8 Zonas participantes de las “Noches comunitarias. ”" },
  { value: "1.4.1.9", label: "1.4.1.9 Eventos deportivos interbarriales e interveredales realizados y/o apoyados. " },
  {
    value: "1.4.1.10",
    label:
      "1.4.1.10 Torneos y festivales deportivos y recreativos realizados y/o apoyados de manera descentralizada. ",
  },
  {
    value: "1.4.1.11",
    label:
      "1.4.1.11 Eventos deportivos interinstitucionales con proyección externa al municipio realizados y/o apoyados. ",
  },
  {
    value: "1.4.2.1",
    label: "1.4.2.1 Capacitaciones a los formadores, entrenadores y expertos deportivos brindadas. ",
  },
  {
    value: "1.4.2.2",
    label: "1.4.2.2 Equipo interdisciplinar para el acompañamiento y asesoramiento a deportistas creado. ",
  },
  {
    value: "1.4.2.3",
    label:
      "1.4.2.3 Fondo económico para apoyo a deportistas que representen al municipio en competencias externas creado. ",
  },
  { value: "1.4.2.4", label: "1.4.2.4 Infraestructura deportiva mantenida y mejorada. " },
  { value: "1.4.2.5", label: "1.4.2.5 Infraestructura deportiva construida. " },
  { value: "1.4.3.1", label: "1.4.3.1 Plan Integral de Educación Física y Deporte creado e implementado. " },
  {
    value: "1.4.3.2",
    label: "1.4.3.2 Sedes Educativas con implementación del Plan Integral de Educación Física y Deporte. ",
  },
  { value: "1.4.3.3", label: "1.4.3.3 Establecimiento del INDER Copacabana. " },
  {
    value: "1.4.3.4",
    label:
      "1.4.3.4 Dotación deportiva entregada para brindar condiciones adecuadas en la realización de la actividad deportiva. ",
  },
  { value: "1.4.3.5", label: "1.4.3.5 Alianzas con diferentes actores realizadas para la gestión deportiva. " },
  { value: "2.1.1.1", label: "2.1.1.1 SILAP formulado con gestión para su implementación. " },
  { value: "2.1.1.2", label: "2.1.1.2 Generación de Espacios Públicos Verdes Urbanos. " },
  {
    value: "2.1.1.3",
    label: "2.1.1.3 Estrategia de reforestación y restauración de áreas de importancia ambiental en el municipio. ",
  },
  { value: "2.1.1.4", label: "2.1.1.4 Área total para la protección y conservación de ecosistemas naturales. " },
  { value: "2.1.2.1", label: "2.1.2.1 Áreas con PSA. " },
  { value: "2.1.2.2", label: "2.1.2.2 Intervenciones en acueductos veredales para su mejora y fortalecimiento. " },
  {
    value: "2.1.2.3",
    label:
      "2.1.2.3 Acciones integrales con capacitaciones, sensibilizaciones, acompañamientos y monitoreos para Protección y Gestión Sostenible del Agua implementadas. ",
  },
  { value: "2.1.2.4", label: "2.1.2.4 Análisis hidrológico de cuencas con enfoque regenerativo. " },
  {
    value: "2.1.2.5",
    label:
      "2.1.2.5 Intervenciones mediante descontaminación en el Sistema de alcantarillado, pozos sépticos y control de descargas directas para su fortalecimiento. ",
  },
  {
    value: "2.1.3.1",
    label:
      "2.1.3.1 Acciones de planificación, gestión, control y monitoreo ambiental en Copacabana implementadas para enfrentar los fenómenos del cambio climático. ",
  },
  { value: "2.1.3.2", label: "2.1.3.2 Diseño de ruta estratégica para adaptación al cambio climático. " },
  {
    value: "2.1.3.3",
    label:
      "2.1.3.3 Diseño e implementación del plan de ahorro y eficiencia energética para la administración pública, y la promoción de energías renovables. ",
  },
  {
    value: "2.1.3.4",
    label:
      "2.1.3.4 Acciones enfocadas en la implementación de medidas de adaptación y resiliencia de la infraestructura. ",
  },
  {
    value: "2.1.4.1",
    label:
      "2.1.4.1 Campañas de capacitación y sensibilización en cambio climático, adaptación y gestión del riesgo. ",
  },
  {
    value: "2.1.4.2",
    label:
      "2.1.4.2 Campañas de capacitación y sensibilización en manejo integral de residuos sólidos y sostenibilidad. ",
  },
  {
    value: "2.1.4.3",
    label:
      "2.1.4.3 Estrategia para el mejoramiento y construcción de espacios para la formación e investigación ambiental. ",
  },
  {
    value: "2.1.4.4",
    label: "2.1.4.4 Acciones enfocadas en impulsar la educación ambiental y la transformación cultural. ",
  },
  { value: "2.1.5.1", label: "2.1.5.1 Plan de Gestión Integral de Residuos actualizado. " },
  {
    value: "2.1.5.2",
    label:
      "2.1.5.2 Acciones implementadas para la formalización de recuperadores y el fortalecimiento de empresas de reciclaje. ",
  },
  { value: "2.1.6.1", label: "2.1.6.1 Acciones con enfoque en economía circular. " },
  { value: "2.1.6.2", label: "2.1.6.2 Acciones enfocadas en acompañamiento, control y vigilancia ambiental. " },
  { value: "2.1.6.3", label: "2.1.6.3 Programa participativo de Sello Ambiental. " },
  {
    value: "2.2.1.1",
    label:
      "2.2.1.1 Política pública de bienestar animal para la protección y promoción del bienestar de los animales diseñada. ",
  },
  { value: "2.2.1.2", label: "2.2.1.2 Creación de Infraestructura y Unidades de Atención y Bienestar Animal. " },
  {
    value: "2.2.1.3",
    label:
      "2.2.1.3 Cátedra de Bienestar animal implementada en las instituciones educativas oficiales del municipio. ",
  },
  {
    value: "2.2.1.4",
    label: "2.2.1.4 Atención integral a animales en condición de vulnerabilidad reportados y/o identificados. ",
  },
  {
    value: "2.2.1.5",
    label: "2.2.1.5 Campañas de salud, bienestar, adopción y sensibilización para Mascotas realizadas. ",
  },
  { value: "2.3.1.1", label: "2.3.1.1 Plan de Gestión del Riesgo Institucional actualizado. " },
  {
    value: "2.3.1.2",
    label:
      "2.3.1.2 Acciones de control y seguimiento necesario a las especies invasoras del municipio, con mapeo de zonas, seguimiento a tendencias, divulgación a la comunidad,  realizadas. ",
  },
  {
    value: "2.3.1.3",
    label:
      "2.3.1.3 Acciones Correctivas y Preventivas, a través de medios comunicacionales, visitas a sitios, capacitaciones y formaciones, realizadas en torno a la gestión integral del riesgo de desastres. ",
  },
  {
    value: "2.3.2.1",
    label:
      "2.3.2.1 Estrategia de Verificación Cumplimiento Normativo y Supervisión de Construcciones diseñada e implementada. ",
  },
  { value: "2.3.3.1", label: "2.3.3.1 Sistemas de Monitoreo y Alerta Temprana implementados. " },
  { value: "2.3.3.2", label: "2.3.3.2 Nueva Sede de Bomberos actualizada y con condiciones adecuadas. " },
  { value: "2.3.3.3", label: "2.3.3.3 Dotación de organismos de socorro y salvaguardia gestionados. " },
  { value: "2.4.1.1", label: "2.4.1.1 Copacabana con Vivienda Digna: Mejoramiento de viviendas realizados. " },
  {
    value: "2.4.1.2",
    label: "2.4.1.2 Copacabana con Vivienda Digna: construcciones de vivienda nueva viabilizadas. ",
  },
  {
    value: "2.4.1.3",
    label:
      "2.4.1.3 Personas beneficiadas con asesoría integral para acceder a beneficios económicos para proyectos de vivienda de interés social (VIS), vivienda de interés prioritario (VIP) y mejoramiento de vivienda. ",
  },
  { value: "2.4.1.4", label: "2.4.1.4 Iniciativas de saneamiento y titulación de bienes fiscales ejecutadas. " },
  {
    value: "2.5.1.1",
    label:
      "2.5.1.1 Acciones de fortalecimiento de la Movilidad en Copacabana, como campañas de sensibilización, asesorías, capacitaciones y acompañamientos, de manera sostenible y con enfoque diferencial implementadas. ",
  },
  {
    value: "2.5.1.2",
    label: "2.5.1.2 Plan integral para el mejoramiento de la movilidad en el municipio de Copacabana diseñado. ",
  },
  { value: "2.5.1.3", label: "2.5.1.3 Parque automotor Público mejorado. " },
  {
    value: "2.5.2.1",
    label: "2.5.2.1 Intervenciones para lograr la mejora y/o ampliación de la infraestructura vial. ",
  },
  { value: "2.5.2.2", label: "2.5.2.2 Mantenimiento de la infraestructura vial. " },
  {
    value: "2.5.3.1",
    label: "2.5.3.1 Estrategia 'Copacabana, hacia una movilidad innovadora e  inteligente' implementada. ",
  },
  { value: "2.5.3.2", label: "2.5.3.2 Acciones de Educación y Cultura Vial implementadas. " },
  { value: "2.6.1.1", label: "2.6.1.1 Plan Básico de Ordenamiento Territorial de Copacabana actualizado. " },
  { value: "2.6.2.1", label: "2.6.2.1 Infraestructura municipal de Copacabana mejorada o mantenida. " },
  { value: "2.6.2.2", label: "2.6.2.2 Sistema de alumbrado público municipal mejorado y ampliado. " },
  {
    value: "2.6.2.3",
    label:
      "2.6.2.3 Estrategia de integración de espacios públicos seguros, estimulantes y adecuados para niños y niñas diseñada y ejecutada. ",
  },
  { value: "2.6.2.4", label: "2.6.2.4 Espacio público de Copacabana mejorado. " },
  { value: "2.6.2.5", label: "2.6.2.5 Gestionar el aumento de cobertura de la red de gas en la zona veredal. " },
  { value: "3.1.1.1", label: "3.1.1.1 Emprendimientos fortalecidos y promovidos. " },
  { value: "3.1.1.2", label: "3.1.1.2 Estrategias de integración y financiación empresarial implementadas. " },
  {
    value: "3.1.1.3",
    label: "3.1.1.3 Capacitaciones realizadas a emprendimientos para la creación y consolidación de empresa. ",
  },
  { value: "3.1.1.4", label: "3.1.1.4 Eventos para el fomento del emprendimiento realizados. " },
  {
    value: "3.1.2.1",
    label:
      "3.1.2.1 Campañas para la estimulación de la creación, formalización y mejoramiento de emprendimientos realizadas. ",
  },
  { value: "3.1.2.2", label: "3.1.2.2 Estrategia 'Emprendimiento para el Futuro' implementada. " },
  {
    value: "3.1.2.3",
    label:
      "3.1.2.3 Acciones de formación para generación de competencias y habilidades (empleos de futuro e industria Tech) realizadas. ",
  },
  { value: "3.1.2.4", label: "3.1.2.4 Convenios público/privados para el fortalecimiento del empleo realizados. " },
  {
    value: "3.1.3.1",
    label: "3.1.3.1 Empresas entorno a la estrategia de 'Semaforización empresarial' clasificadas. ",
  },
  {
    value: "3.1.3.2",
    label: "3.1.3.2 Estrategia de semaforización empresarial para la sostenibilidad implementada. ",
  },
  {
    value: "3.1.3.3",
    label: "3.1.3.3 Incentivos tributarios para empresas que se asienten en el municipio generados. ",
  },
  { value: "3.1.3.4", label: "3.1.3.4 Estrategia 'El alcalde visita tu empresa' implementada. " },
  { value: "3.1.4.1", label: "3.1.4.1 Redes empresariales diseñadas e implementadas. " },
  { value: "3.1.4.2", label: "3.1.4.2 Capacitaciones, asesorías y alianzas con la mesa empresarial realizadas. " },
  {
    value: "3.1.4.3",
    label:
      "3.1.4.3 Red de Negocios Copacabana e integración regional con el distrito de Ciencia, Tecnología e Innovación de Medellín diseñada e implementada. ",
  },
  {
    value: "3.1.5.1",
    label: "3.1.5.1 Acciones de fortalecimiento de la oficina de empleo en Copacabana implementadas. ",
  },
  {
    value: "3.1.5.2",
    label: "3.1.5.2 Acciones para la promoción de empleo de la mano de la oficina pública de empleo implementadas. ",
  },
  { value: "3.2.1.1", label: "3.2.1.1 Plan Agropecuario Municipal (PAM) formulado e implementado. " },
  {
    value: "3.2.1.2",
    label:
      "3.2.1.2 Acciones de fortalecimiento para la producción y comercialización del sector agropecuario, como capacitaciones, acompañamiento, asesorías, entre otras, realizadas. ",
  },
  { value: "3.2.1.3", label: "3.2.1.3 Estrategia de 'eco huertas comunitarias' implementada. " },
  {
    value: "3.2.1.4",
    label:
      "3.2.1.4 Acciones de formación para el desarrollo de capacidades e iniciativas para esquemas asociativos en el sector agropecuario. ",
  },
  { value: "3.2.2.1", label: "3.2.2.1 Estrategia 'Mercado Campesino Sostenible' implementada. " },
  { value: "3.2.2.2", label: "3.2.2.2 Acciones para el desarrollo de cadenas de valor y comercialización. " },
  {
    value: "3.2.2.3",
    label:
      "3.2.2.3 Acciones para que la Plaza de mercado sea un espacio óptimo para la comercialización y el impulso de las cooperativas y/o asociaciones agrícolas y pecuarias mejorada. ",
  },
  { value: "3.3.1.1", label: "3.3.1.1 Política pública de turismo con enfoque sostenible diseñada y expedida. " },
  { value: "3.3.2.1", label: "3.3.2.1 Ecosistema Empresarial Turístico implementado. " },
  {
    value: "3.3.2.2",
    label:
      "3.3.2.2 Acciones de capacitación, acompañamientos, asesorías, divulgación, promoción para implementar el Turismo Comunitario y Cultural en el territorio. ",
  },
  { value: "3.3.2.3", label: "3.3.2.3 Acciones de Endomarketing turístico implementadas. " },
  {
    value: "3.3.2.4",
    label: "3.3.2.4 Asesorías y capacitaciones a los prestadores de servicios turísticos en el municipio. ",
  },
  { value: "3.3.2.5", label: "3.3.2.5 Marca Turística de Copacabana creada. " },
  {
    value: "3.3.2.6",
    label: "3.3.2.6 Estrategia para la promoción de la Marca Municipio de Copacabana implementada. ",
  },
  { value: "3.3.3.1", label: "3.3.3.1 Infraestructura turística mejorada. " },
  {
    value: "3.3.3.2",
    label:
      "3.3.3.2 Estudios de capacidad de carga en los puntos turísticos prioritarios del municipio de Copacabana realizados. ",
  },
  { value: "3.3.3.3", label: "3.3.3.3 Sistema de información turística implementado. " },
  { value: "3.4.1.1", label: "3.4.1.1 Oficina de cooperación internacional, innovación y desarrollo creada. " },
  {
    value: "3.4.1.2",
    label: "3.4.1.2 Reemplazo de fuentes de suministro de energía eléctrica para edificaciones públicas. ",
  },
  {
    value: "3.4.2.1",
    label:
      "3.4.2.1 Acciones de formación en capacidades digitales y la adopción de nuevas tecnologías 4.0 realizadas. ",
  },
  {
    value: "3.4.3.1",
    label:
      "3.4.3.1 Acciones ligadas a la cualificación, actualización digital y dotación tecnológica para la gestión de mejora de la infraestructura tecnológica realizadas. ",
  },
  { value: "3.4.4.1", label: "3.4.4.1 Estrategia Copacabana ciudad inteligente diseñada. " },
  {
    value: "3.4.4.2",
    label:
      "3.4.4.2 Acciones para el acceso y uso de las Tecnologías de la Información y las Comunicaciones implementadas en el marco de Ciudad Inteligente. ",
  },
  {
    value: "4.1.1.1",
    label:
      "4.1.1.1 Estrategia para desarrollo integral de la primera infancia implementada: acceso a los servicios básicos, acompañamiento psicosocial y protección de derechos. ",
  },
  { value: "4.1.1.2", label: "4.1.1.2 Estrategia para la atención integral a madres gestantes implementadas. " },
  {
    value: "4.1.1.3",
    label: "4.1.1.3 Plan Municipal de Prevención Integral de abuso sexual infantil implementada. ",
  },
  {
    value: "4.1.1.4",
    label:
      "4.1.1.4 Acciones de seguimiento, control y mejoras para la seguridad nutricional y alimentaria implementadas. ",
  },
  { value: "4.1.1.5", label: "4.1.1.5 Estrategia de entornos protectores y seguros implementada. " },
  { value: "4.1.2.1", label: "4.1.2.1 Infraestructura mejorada. " },
  {
    value: "4.2.1.1",
    label: "4.2.1.1 Estrategia para el desarrollo integral de la niñez y adolescencia implementada. ",
  },
  {
    value: "4.3.1.1",
    label:
      "4.3.1.1 Adultos mayores beneficiados con acciones de bienestar, fortalecimiento y protección integral implementadas. ",
  },
  {
    value: "4.3.1.2",
    label:
      "4.3.1.2 Política pública de envejecimiento humano y vejez, que incluya los programas de 'Resignificación y protección del adulto mayor' para entornos adecuados y 'Dignidad en la veje' que incluya actividades lúdicas, recreativas, culturales y deportivas actualizada. ",
  },
  { value: "4.3.1.3", label: "4.3.1.3 Acciones de promoción del subsidio de adulto mayor realizadas. " },
  {
    value: "4.3.1.4",
    label: "4.3.1.4 Viabilización de la Construcción y dotación del Centro del Adulto Mayor gestionado. ",
  },
  {
    value: "4.3.1.5",
    label:
      "4.3.1.5 Estrategia de estímulos, incentivos y reconocimientos a los adultos mayores reconociendo su labor y papel en la comunidad realizada. ",
  },
  { value: "4.3.1.6", label: "4.3.1.6 Festival recreativo, cultural, deportivo del adulto mayor realizado. " },
  { value: "4.4.1.1", label: "4.4.1.1 Política pública de juventud actualizada. " },
  { value: "4.4.1.2", label: "4.4.1.2 Estrategia 'STEAM Zone' para formación especializada en STEAM implementada. " },
  {
    value: "4.4.1.3",
    label:
      "4.4.1.3 Programa de acompañamiento integral a jóvenes (emocional, social, económico) creado e implementado. ",
  },
  {
    value: "4.4.1.4",
    label:
      "4.4.1.4 Acciones de seguimiento, formación, acompañamiento y asesoramiento dirigidas al fortalecimiento del Consejo municipal de Juventud y de la plataforma municipal de juventud desarrolladas. ",
  },
  {
    value: "4.4.1.5",
    label:
      "4.4.1.5 Capacitaciones y asesorías a personeros estudiantiles para fortalecer sus labores de líderes y gestores ante el municipio realizadas. ",
  },
  { value: "4.4.1.6", label: "4.4.1.6 Casa de la juventud planeada y creada. " },
  {
    value: "4.4.1.7",
    label:
      "4.4.1.7 Acciones de formación y/o capacitación juvenil para el fortalecimiento de los jóvenes emprendedores del municipio desarrolladas. ",
  },
  {
    value: "4.4.1.8",
    label:
      "4.4.1.8 Convenios público-privados para generar programas de acompañamiento y fortalecimiento de actividades no convencionales y educación no formal para los jóvenes, en el marco del programa 'Más Oportunidades para Nuestros Jóvenes'  realizados. ",
  },
  { value: "4.4.1.9", label: "4.4.1.9 Estrategia 'jóvenes talento' implementada. " },
  {
    value: "4.5.1.1",
    label:
      "4.5.1.1 Acciones de acompañamiento, formación y creación de alianzas para empoderamiento y autonomía femenina implementadas. ",
  },
  { value: "4.5.1.2", label: "4.5.1.2 Estrategia integral 'Mujeres Seguras y Libres de Violencia' implementada. " },
  {
    value: "4.5.1.3",
    label: "4.5.1.3 'La casa morada': un lugar de encuentro para las mujeres y con atención priorizada creada. ",
  },
  {
    value: "4.5.1.4",
    label:
      "4.5.1.4 Programa integral de protección de víctimas de la violencia, líderes sociales y madres cabeza de familia. ",
  },
  { value: "4.5.1.5", label: "4.5.1.5 Red de apoyo de las madres cabeza de hogar creada e implementada. " },
  {
    value: "4.5.1.6",
    label:
      "4.5.1.6 Estrategia integral de promoción y prevención en salud especializada en enfermedades de las mujeres implementada. ",
  },
  {
    value: "4.5.1.7",
    label: "4.5.1.7 Estrategia de creación de escuela de liderazgo Mujeres Líderes y Participativas. ",
  },
  { value: "4.5.1.8", label: "4.5.1.8 Política pública de la mujer actualizada. " },
  { value: "4.5.1.9", label: "4.5.1.9 Dirección municipal de las mujeres en Copacabana creada. " },
  {
    value: "4.6.1.1",
    label:
      "4.6.1.1  Acciones de fortalecimiento integral a través de acompañamiento, asesorías, alianzas estratégicas y capacitaciones de la población LGTIQA+ implementadas. ",
  },
  { value: "4.6.1.2", label: "4.6.1.2 Política pública municipal de diversidad diseñada e implementada. " },
  {
    value: "4.6.1.3",
    label:
      "4.6.1.3 Programa 'Desde mi realidad' como estrategia de comunicación multimodal para la población LGBTIQA+ implementada. ",
  },
  { value: "4.6.1.4", label: "4.6.1.4 Mesa diversa fortalecida. " },
  {
    value: "4.6.1.5",
    label: "4.6.1.5 'Casa de Colores': Espacio de Encuentro y con atención integral para la diversidad adecuada. ",
  },
  {
    value: "4.6.1.6",
    label: "4.6.1.6 Acciones de Educación Inclusiva, laboral y Sensibilización Comunitaria implementadas. ",
  },
  { value: "4.7.1.1", label: "4.7.1.1 Centro de Atención Integral para la Discapacidad (CAID) creado. " },
  { value: "4.7.1.2", label: "4.7.1.2 Capacitaciones a los cuidadores de personas con Discapacidad realizadas. " },
  {
    value: "4.7.1.3",
    label:
      "4.7.1.3 Acciones para empresas, emprendimiento y comercios con capacitaciones, divulgación, concientización, entre otras, para Inclusión Laboral para Personas con Discapacidad implementadas. ",
  },
  { value: "4.7.1.4", label: "4.7.1.4 Plan ocupacional para personas con discapacidad diseñado. " },
  { value: "4.7.1.5", label: "4.7.1.5 Acciones para la Accesibilidad y Movilidad Urbana implementadas. " },
  {
    value: "4.7.1.6",
    label:
      "4.7.1.6 Encuentros de bienestar emocional, estimulación, creatividad y expresión para las personas con discapacidad. ",
  },
  {
    value: "4.7.1.7",
    label:
      "4.7.1.7 Acciones de Empoderamiento y Participación Comunitaria de personas con discapacidad implementadas. ",
  },
  { value: "4.8.1.1", label: "4.8.1.1 Estrategia de Atención psicosocial y resocialización implementada. " },
  {
    value: "4.8.1.2",
    label:
      "4.8.1.2 Acciones de acompañamiento, formación y campañas de divulgación para promover programas de desintoxicación implementadas. ",
  },
  { value: "4.8.1.3", label: "4.8.1.3 Política pública para personas en situación de calle diseñada y expedida. " },
  {
    value: "4.9.1.1",
    label:
      "4.9.1.1 Espacios de participación liderados por el sector religioso, para la garantía del derecho con plan de acción implementado. ",
  },
  {
    value: "4.9.1.2",
    label: "4.9.1.2 Organizaciones basadas en la fe con proyectos de cooperación social y comunitarios formulados. ",
  },
  {
    value: "4.9.1.3",
    label:
      "4.9.1.3 Acciones que promuevan un entorno protector alrededor de los lugares de culto, dentro del Plan Integral de Seguridad y Convivencia Ciudadana (PISCC). ",
  },
  {
    value: "4.9.1.4",
    label: "4.9.1.4 Capacitaciones para la promoción y protección del derecho a la libertad religiosa. ",
  },
  {
    value: "4.9.1.5",
    label: "4.9.1.5 Política pública de libertad religiosa y de cultos formulada e implementada. ",
  },
  { value: "4.10.1.1", label: "4.10.1.1 Ruta Integral de Acompañamiento a Víctimas (RIAV) actualizada. " },
  {
    value: "4.10.1.2",
    label:
      "4.10.1.2 Estrategia de articulación a los programas de apoyo y atención del gobierno nacional y departamental con las víctimas de Copacabana implementada. ",
  },
  { value: "4.10.1.3", label: "4.10.1.3 Oficina de Atención a Víctimas fortalecida. " },
  {
    value: "4.10.1.4",
    label:
      "4.10.1.4 Acciones de promoción del reconocimiento y respaldo a las iniciativas de las personas y organizaciones de víctimas en el marco del proceso de reparación integral y la búsqueda de reconciliación realizadas. ",
  },
  {
    value: "4.10.1.5",
    label:
      "4.10.1.5 Acciones de Empoderamiento y Participación de las Víctimas en la Construcción de Paz implementadas. ",
  },
  { value: "4.10.1.6", label: "4.10.1.6 Política pública de víctimas implementada. " },
  {
    value: "4.11.1.1",
    label:
      "4.11.1.1 Acciones preventivas y operativas que aporten a la seguridad integral, desde la formación ciudadana, integración de la policía cívica, divulgación y promoción de seguridad, tomas de espacios, entre otros. ",
  },
  {
    value: "4.11.1.2",
    label: "4.11.1.2 Capacitaciones a la comunidad sobre autocuidado con perspectiva de prevención del delito. ",
  },
  {
    value: "4.11.1.3",
    label: "4.11.1.3 Acciones que garanticen entornos protectores y seguros para niños, niñas y adolescentes. ",
  },
  { value: "4.11.1.4", label: "4.11.1.4 Adecuación y dotación de las comisarías de familia. " },
  { value: "4.11.1.5", label: "4.11.1.5 Capacitación y asesorías técnicas a las comisarías de familias. " },
  { value: "4.11.1.6", label: "4.11.1.6 Consejos de seguridad descentralizados realizados. " },
  {
    value: "4.11.1.7",
    label: "4.11.1.7 Convenio estratégico con el transporte público para la seguridad gestionado. ",
  },
  {
    value: "4.11.1.8",
    label:
      "4.11.1.8 Convenios estratégicos con la policía nacional de carabineros y el ejército nacional gestionados. ",
  },
  {
    value: "4.11.1.9",
    label: "4.11.1.9 Planes Integrales de Seguridad y Convivencia Ciudadana -PISCC diseñados e implementados. ",
  },
  { value: "4.11.1.10", label: "4.11.1.10 CAI Móviles viabilizados. " },
  {
    value: "4.11.1.11",
    label:
      "4.11.1.11 Desarrollo de estrategia de seguridad cercana a las comunidades a través de recorridos en el municipio. ",
  },
  { value: "4.11.1.12", label: "4.11.1.12 Estrategia de reacción inmediata con la Policía Nacional implementada. " },
  {
    value: "4.11.1.13",
    label: "4.11.1.13 Articulación con los entes territoriales de las estrategias de seguridad realizada. ",
  },
  { value: "4.11.1.14", label: "4.11.1.14 Nueva estación de policía con condiciones adecuadas viabilizada. " },
  { value: "4.11.1.15", label: "4.11.1.15 Frentes de seguridad constituidos. " },
  { value: "4.11.2.1", label: "4.11.2.1 Jornadas de educación, convivencia y seguridad realizadas. " },
  {
    value: "4.11.2.2",
    label:
      "4.11.2.2 Acciones de Reconstrucción del Tejido Social a través del Arte y el Deporte para la convivencia implementadas. ",
  },
  {
    value: "4.11.2.3",
    label:
      "4.11.2.3 Estrategia de apropiación de espacios con programas de inserción cultural para la sana convivencia. ",
  },
  { value: "4.11.2.4", label: "4.11.2.4 Talleres juveniles con gestión comunitaria de la policía. " },
  { value: "4.11.3.1", label: "4.11.3.1 Seguridad informática y protección de la información pública fortalecida. " },
  { value: "4.11.3.2", label: "4.11.3.2 Estrategia de integración tecnológica para la seguridad implementada. " },
  { value: "4.11.3.3", label: "4.11.3.3 Centro de comunicaciones, comando y control modernizado. " },
  {
    value: "5.1.1.1",
    label:
      "5.1.1.1 Estrategia de fortalecimiento de la Capacidad Analítica y Gestión de la Información Financiera realizada. ",
  },
  {
    value: "5.1.1.2",
    label:
      "5.1.1.2 Estrategia para la generación de ingresos municipales y la gestión de recursos territoriales implementada. ",
  },
  { value: "5.1.2.1", label: "5.1.2.1 Acciones de promoción y fortalecimiento de los mecanismos de denuncia. " },
  {
    value: "5.1.2.2",
    label: "5.1.2.2 Estrategia para la prevención del conflicto de interés creada e implementada. ",
  },
  { value: "5.1.2.3", label: "5.1.2.3 Código de integridad para los funcionarios fortalecido. " },
  {
    value: "5.1.2.4",
    label:
      "5.1.2.4 Estrategia para el fortalecimiento de la gestión pública del municipio de Copacabana implementada. ",
  },
  {
    value: "5.1.2.5",
    label:
      "5.1.2.5 Acciones de fortalecimiento de las organizaciones de la sociedad civil implementadas, a través, de acompañamiento, formación y divulgación. ",
  },
  { value: "5.1.2.6", label: "5.1.2.6 Oficina de atención al ciudadano fortalecida. " },
  { value: "5.2.1.1", label: "5.2.1.1 Mecanismo de participación ciudadana y comunal creado e implementado. " },
  {
    value: "5.2.1.2",
    label:
      "5.2.1.2 Programa de incentivos de las buenas prácticas, gestiones y acciones de los organismos comunales creados. ",
  },
  { value: "5.2.1.3", label: "5.2.1.3 Formaciones en Auditoría Ciudadana y Control Social realizadas. " },
  {
    value: "5.2.1.4",
    label:
      "5.2.1.4 Estrategia con las Juntas de Acción Comunal para la ejecución de obras según el marco legal que lo rija creada e implementada. ",
  },
  { value: "5.2.1.5", label: "5.2.1.5 Canales de comunicación directa con la comunidad creados y fortalecidos. " },
  {
    value: "5.2.1.6",
    label: "5.2.1.6 NPS implementado adecuadamente para el mejoramiento de la atención al ciudadano. ",
  },
  { value: "5.2.1.7", label: "5.2.1.7 Dirección de Participación Ciudadana creada. " },
  {
    value: "5.3.1.1",
    label:
      "5.3.1.1 Acciones de fortalecimiento del bienestar integral del personal articulada a la gestión pública implementadas. ",
  },
  { value: "5.3.1.2", label: "5.3.1.2 Calificaciones y capacitaciones a los empleados públicos realizadas. " },
  {
    value: "5.3.1.3",
    label: "5.3.1.3 Programa de incentivos para los empleados públicos sobresalientes creado e implementado. ",
  },
  { value: "5.3.1.4", label: "5.3.1.4 Actualización de los procesos de la administración municipal realizada. " },
  {
    value: "5.3.1.5",
    label: "5.3.1.5 Programa de inducción y reinducción de los empleados públicos fortalecido y actualizado. ",
  },
  {
    value: "5.3.1.6",
    label:
      "5.3.1.6 Creación del programa 'Somos equipo' como espacios de integración, formación y fortalecimiento del bienestar integral. ",
  },
  {
    value: "5.3.1.7",
    label: "5.3.1.7 Estrategia de modernización y articulación de la gestión pública implementada. ",
  },
  { value: "5.3.1.8", label: "5.3.1.8 Capacitaciones a funcionarios en habilidades digitales realizadas. " },
  { value: "5.3.1.9", label: "5.3.1.9 Espacios físicos de la administración municipal mejorados. " },
  {
    value: "5.3.1.10",
    label:
      "5.3.1.10 Estrategia de actualización del equipo tecnológico de la administración municipal realizada e implementada. ",
  },
  { value: "5.3.1.11", label: "5.3.1.11 Plan de comunicación implementado, adaptado y socializado. " },
  { value: "5.3.1.12", label: "5.3.1.12 Rendición de cuentas planeado y ejecutado. " },
  { value: "5.3.1.13", label: "5.3.1.13 Creación y puesta en marcha de la mesa de Comunicaciones. " },
]
const opcionesBPIN = [
  { value: "", label: "Seleccionar..." },
  {
    value: "2024052120001",
    label:
      "Construcción de redes de alcantarillado convencional no convencional e interceptor secundario para aguas residuales domésticas en el centropoblado de la vereda El Cabuyal del municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120002",
    label: "Construcción de obra hidráulica en el barrio María sector Acarpín Copacabana. ",
  },
  {
    value: "2024052120003",
    label:
      "Construcción de sistema de contención en la vereda Cabuya sector La Romerita en el municipio de Copacabana. ",
  },
  {
    value: "2024052120004",
    label:
      "Construcción de un sistema de contención en anclaje para la Vereda Alvarado sector La Bola en el municipio de Copacabana. ",
  },
  {
    value: "2024052120005",
    label:
      "Construcción de muro de contención para el barrio La Azulita sector Placa Deportiva en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120006",
    label:
      "Construcción de muro de contención para el barrio Yarumito sector Barrientos en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120007",
    label:
      "Construcción de muro de contención en el sector La Y vereda Quebrada Arriba en el municipio de Copacabana. ",
  },
  {
    value: "2024052120008",
    label:
      "Construcción de muro de contención en la zona Marginal quebrada Piedras Blancas barrio Yarumito en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120009",
    label:
      "Construcción de muro de contención en la vereda Cabuyal Sector Marquitos en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120010",
    label:
      "Construcción de estructura de contención para placa polideportiva en el barrio Las Vegas parte alta Copacabana. ",
  },
  {
    value: "2024052120011",
    label:
      "Fortalecimiento del Sistema Integrado de Emergencias y Seguridad SIES con la modernización el Centro de Monitoreo del Municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120012",
    label:
      "Construcción de una infraestructura multidisciplinaria para la formación y circulación artística y cultural de Copacabana. ",
  },
  {
    value: "2024052120013",
    label:
      "Adquisición de unidad móvil de salud para fortalecer el servicio de atención extramural de las actividades de promoción y prevención de ese hospital santa margarita para la comunidad del municipio Copacabana. ",
  },
  {
    value: "2024052120014",
    label:
      "Fortalecimiento de la operación del Cuerpo de Bomberos mediante la adquisición de equipos en el municipio de Copacabana. ",
  },
  {
    value: "2024052120015",
    label:
      "Implementación y actualización de Plan Básico de Ordenamiento Territorial (PBOT) en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120016",
    label:
      "Desarrollo de acciones estratégicas para el fortalecimiento de la gestión institucional en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120017",
    label:
      "Implementación de acciones para la actualización y cobertura del Sisbén en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120018",
    label:
      "Fortalecimiento de la gestión integral de la oferta hídrica y saneamiento básico en el Municipio Copacabana Antioquia. ",
  },
  {
    value: "2024052120019",
    label: "Fortalecimiento del Bienestar animal y la tenencia responsable Copacabana Antioquia. ",
  },
  {
    value: "2024052120020",
    label:
      "Fortalecimiento de la educación y cultura ambiental territorializada en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120021",
    label:
      "Implementación de medidas para la protección conservación y restauración de los ecosistemas naturales de alto valor ecológico cultural y social del municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120022",
    label:
      "Implementación de acciones para la gestión integral de residuos sólidos en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120023",
    label:
      "Apoyo al fortalecimiento y desarrollo de cadenas de valor y promoción de productos locales en el Municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120024",
    label:
      "Fortalecimiento del Desarrollo Agropecuario Sostenible en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120025",
    label:
      "Implementación de estrategias para mitigación y adaptación del cambio climático Copacabana Antioquia. ",
  },
  {
    value: "2024052120026",
    label:
      "Fortalecimiento de la Producción Verde y Responsable del municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120027",
    label:
      "Fortalecimiento y mejoramiento de la gestión administrativa de los procesos internos y de las Tecnologías de la información y las Comunicaciones del municipio de Copacabana Copacabana.",
  },
  {
    value: "2024052120028",
    label:
      "Fortalecimiento de la gestión del talento humano y bienestar laboral del municipio de Copacabana. ",
  },
  {
    value: "2024052120029",
    label: "Desarrollo integral a niños, niñas y adolescentes en el municipio de Copacabana. ",
  },
  {
    value: "2024052120030",
    label:
      "Desarrollo e implementación de procesos y estrategias efectivas que impulsen el fortalecimiento integral del desarrollo económico en Copacabana Antioquia. ",
  },
  {
    value: "2024052120031",
    label:
      "Fortalecimiento integral a las victimas del conflicto armado y su reparación brindarles apoyo para superar y reencontrar su salud mental económico y social en el Municipio Copacabana. ",
  },
  {
    value: "2024052120032",
    label:
      "Fortalecimiento de la participación ciudadana de las organizaciones de la sociedad civil comunitarias yo comunales en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120033",
    label:
      "Fortalecimiento de las estrategias para el desarrollo integral de las mujeres y el cumplimiento de sus derechos en el municipio de Copacabana. ",
  },
  {
    value: "2024052120034",
    label:
      "Construcción de acciones estratégicas para el fortalecimiento integral de los adolescentes y jóvenes del municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120035",
    label:
      "Apoyo y atención integral a la población que se encuentra en situación de calle del municipio de Copacabana. ",
  },
  {
    value: "2024052120036",
    label:
      "Implementación de acciones y estrategias para ampliar la oferta institucional que permita una atención integral para las personas con discapacidad sus familias yo cuidadores. Copacabana. ",
  },
  {
    value: "2024052120037",
    label:
      "Implementación de un ecosistema turístico orientado al crecimiento económico y comunitario con un enfoque integral sostenible e incluyente para el municipio de Copacabana. ",
  },
  {
    value: "2024052120038",
    label:
      "Implantación del programa integral de seguridad e instrumentos de planificación y gestión como el plan de seguridad para el mejoramiento de la seguridad y convivencia ciudadana en el municipio de Copacabana. ",
  },
  {
    value: "2024052120039",
    label:
      "Reconstrucción del tejido social a través del arte y el deporte para la promoción de la sana convivencia y la prevención de delitos en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120040",
    label:
      "Implantación de soluciones comunitarias y con la modernización tecnológica enfocada en la prevención del delito en el municipio de Copacabana. ",
  },
  {
    value: "2024052120041",
    label:
      "Fortalecimiento de la Movilidad Sostenible con enfoque diferencial en el municipio de Copacabana. ",
  },
  {
    value: "2024052120042",
    label:
      "Implementación de un Sistema de Movilidad Innovador e inteligente en el municipio de Copacabana. ",
  },
  {
    value: "2024052120043",
    label:
      "Construcción de gimnasios al aire libre en la zona urbana y rural en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120044",
    label: "Construcción de la piscina semi olímpica del municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120045",
    label: "Modernización de la unidad deportiva principal en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120046",
    label:
      "Construcción y dotación de Placas Polideportivas cubiertas rurales en el municipio de Copacabana. ",
  },
  {
    value: "2024052120047",
    label:
      "Mantenimiento integral de la infraestructura educativa para el desarrollo, la educación y la pedagogía en el municipio de Copacabana. ",
  },
  {
    value: "2024052120048",
    label:
      "Optimización y mantenimiento de acueductos veredales en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120049",
    label:
      "Mejoramiento y mantenimiento de Infraestructura pública en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120050",
    label:
      "Renovación y mantenimiento del Espacio Público disponible en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120051",
    label:
      "Mejoramiento y mantenimiento de la infraestructura Vial urbana y rural disponible en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120052",
    label:
      "Mantenimiento, reposición y expansión del Sistema de Alumbrado Público disponible en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120053",
    label:
      "Mejoramiento y mantenimiento de la infraestructura deportiva disponible en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120054",
    label:
      "Mejoramiento de viviendas dignas para los habitantes del municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120055",
    label:
      "Implantación de una gestión del riesgo integral de desastres en el municipio de Copacabana. ",
  },
  {
    value: "2024052120056",
    label:
      "Fortalecimiento de la comunicación y la Infraestructura Tecnológica para la competitividad en el municipio Copacabana Antioquia. ",
  },
  {
    value: "2024052120057",
    label:
      "Fortalecimiento de la hacienda pública y la gestión de recursos en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120058",
    label: "Fortalecimiento Integral pedagógico y educativo en el municipio de Copacabana. ",
  },
  {
    value: "2024052120059",
    label:
      "Fortalecimiento del acceso y permanencia en el sistema educativo desde un enfoque territorial en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120060",
    label:
      "Fortalecimiento de la capacidad de gestión en el sector cultural a través de la gobernanza cultural eficiente la formación y promoción artística vocacional para la protección y salvaguardia del patrimonio cultura en el municipio de Copacabana. ",
  },
  {
    value: "2024052120061",
    label:
      "Fortalecimiento y mantenimiento de sistemas de saneamiento básico, alcantarillados y pozos sépticos en el municipio de Copacabana. ",
  },
  {
    value: "2024052120062",
    label:
      "Fortalecimiento de los servicios de salud hacia la descentralización ampliando la cobertura de atención en salud en el municipio de Copacabana. ",
  },
  {
    value: "2024052120063",
    label: "Fortalecimiento de los niveles de gobernanza de la salud en el municipio de Copacabana. ",
  },
  {
    value: "2024052120064",
    label: "Fortalecimiento y protección integral del adulto mayor en el municipio de Copacabana. ",
  },
  {
    value: "2024052120065",
    label:
      "Fortalecimiento del Programa de Alimentación Escolar-PAE en las Instituciones y sedes educativas oficiales del municipio de Copacabana. ",
  },
  {
    value: "2024052120066",
    label:
      "Implementación de estrategias para garantizar el desarrollo de acciones que generen estilos de vida saludables en el municipio de Copacabana. ",
  },
  {
    value: "2024052120067",
    label:
      "Mejoramiento y dotación de la infraestructura cultural en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120068",
    label:
      "Fortalecimiento de la practica deportiva la formación y preparación de deportistas aficionados y de alto rendimiento en el municipio de Copacabana. ",
  },
  {
    value: "2024052120069",
    label:
      "Fortalecimiento del secetor religioso espacios de participación y protección del derecho a la libre expresión de culto en el Municipio de Copacabana. ",
  },
  {
    value: "2024052120070",
    label:
      "Fortalecimiento de las capacidades diversas en el cuidado y defensa de los Derechos humanos enfocados en la población LGBTIQA+ delMunicipio de Copacabana Copacabana Copacabana. ",
  },
  {
    value: "2024052120071",
    label: "Remodelación del parque principal SIMÓN BOLÍVAR en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120072",
    label:
      "Implementación y actualización del Plan Básico de Ordenamiento Territorial (PBOT) en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120073",
    label: "Mejoramiento de Parques Infantiles y Gimnasios al aire Libre Copacabana. ",
  },
  {
    value: "2024052120074",
    label:
      "Fortalecimiento de la cultura deportiva para el fomento a la recreación, la actividad física y el deporte en el municipio de Copacabana. ",
  },
  {
    value: "2024052120075",
    label:
      "Desarrollo del liderazgo en gobernanza para la gestión deportiva en el municipio de Copacabana. ",
  },
  {
    value: "2024052120076",
    label:
      "Fortalecimiento de la capacidad institucional y operativa para la atención de emergencias a través del cuerpo de bomberos voluntarios mediante la dotación de un vehículo transportador de agua (CISTERNA) en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120077",
    label:
      "Elaboración de los estudios y diseños para la construcción de la Estación de Policía y la Sede de Bomberos en el municipio de Copacabana Antioquia. ",
  },
  {
    value: "2024052120078",
    label:
      "Fortalecimiento DE LOS PROGRAMA DE ATENCIÓN SOCIAL PARA MEJORAR LA CALIDAD DE VIDA DE LAS PERSONAS ADULTOS MAYORES DEL MUNICIPIO DE Copacabana Antioquia. ",
  },
  {
    value: "2024052120079",
    label:
      "Implantación de estrategias para garantizar el desarrollo de acciones que generen estilos de vida saludables en el municipio de Copacabana. ",
  },
  {
    value: "2024052120080",
    label: "Fortalecimiento de los niveles de gobernanza de la salud en el municipio de Copacabana. ",
  },
  {
    value: "2024052120081",
    label:
      "Construcción del centro cultural multidisciplinario para la formación circulación y presentaciones artísticas en la zona norte del departamento de Copacabana Antioquia. ",
  },
  {
    value: "2024052120082",
    label:
      "Desarrollo de un ecosistema educativo 4.0 que apunte al fortalecimiento y encadenamiento de los diferentes niveles educativos en el municipio de Copacabana. ",
  },
  {
    value: "202500000019875",
    label:
      "Implementación de estrategias pra garantizar el desarrollo de acciones que generen estilos de vida saludables en el Municipio de Copacabana ",
  },
   {
    value: "202500000021153",
    label:
      "Desarrollo de estrategias de gestión cultural a través de la gobernanza cultural eficiente la formación y promoción artística, vocacional,, con la promoción, protección y salvaguardia del patrimonio cultural en el municipio de Copacabana ",
  },
  {
    value: "202500000021180",
    label:
      "Implementación de estrategias para garantizar el acceso, la permanencia y el fortalecimiento integral pedagógico del Sistema educativo en el municipio de Copacabana ",
  },
  {
    value: "20250000002401",
    label:
      "Implementación de estrategias promoción para la convivencia y no repetición con educación informal y operativos de control para garantizar la seguridad en el municipio de Copacabana ",
  },
  {
    value: "202500000019875",
    label:
      "Implementación de estrategias para garantizar el desarrollo de acciones que generen estilos de vida saludables en el municipio de Copacabana ",
  },
  {
    value: "20250000038646",
    label:
      "Construcción de la Estación de Policía en el municipio de Copacabana, Antioquia ",
  },
]
const opcionesModalidad = [
  { value: "", label: "Seleccionar..." },
  { value: "CCE-01", label: " Solicitud de información a los Proveedores" },
  { value: "CCE-02", label: " Licitación pública" },
  { value: "CCE-17", label: " Licitación pública (Obra pública)" },
  { value: "CCE-03", label: " Concurso de méritos con precalificación" },
  { value: "CCE-04", label: " Concurso de méritos abierto" },
  { value: "CCE-05", label: " Contratación directa (con ofertas)" },
  { value: "CCE-06", label: " Selección abreviada menor cuantía" },
  {
    value: "CCE-18",
    label: " Selección Abreviada de Menor Cuantia sin Manifestacion de Interés",
  },
  { value: "CCE-07", label: " Selección abreviada subasta inversa" },
  { value: "CCE-10", label: " Mínima cuantía" },
  {
    value: "CCE-11||01",
    label: " Contratación régimen especial - Selección de comisionista",
  },
  {
    value: "CCE-11||02",
    label: " Contratación régimen especial - Enajenación de bienes para intermediarios idóneos",
  },
  {
    value: "CCE-11||03",
    label: " Contratación régimen especial - Régimen especial",
  },
  {
    value: "CCE-11||04",
    label: " Contratación régimen especial - Banco multilateral y organismos multilaterales",
  },
  {
    value: "CCE-15||01",
    label: " Contratación régimen especial (con ofertas) - Selección de comisionista",
  },
  {
    value: "CCE-15||02",
    label: " Contratación régimen especial (con ofertas) - Enajenación de bienes para intermediarios idóneos",
  },
  {
    value: "CCE-15||03",
    label: " Contratación régimen especial (con ofertas) - Régimen especial",
  },
  {
    value: "CCE-15||04",
    label: " Contratación régimen especial (con ofertas) - Banco multilateral y organismos multilaterales",
  },
  { value: "CCE-16", label: " Contratación directa" },
  { value: "CCE-99", label: "Selección abreviada - acuerdo marco" },
]
const REQUISITOS_LEGALES_PN = [
  "Certificado de inexistencia de personal de planta (firmado por el Alcalde y el Jefe de Oficina de Talento Humano y Desarrollo Organizacional).",
  "RUT (Resolimiento 139 de noviembre 21 de 2012- DIAN) para contratistas nuevos o si el RUT ha sufrido alguna modificación.",
  "Certificado de afiliación al sistema de Seguridad Social Integral. Informar ARL y Tipo de Riesgo 1.",
  "Fotocopia de la cédula de ciudadanía (para contratistas nuevos).",
  "Certificado de no ser deudor fiscal – Contraloría (código de verificación; vigencia mínima 30 días).",
  "Certificado de antecedentes disciplinarios – Procuraduría (vigencia mínima 30 días).",
  "Certificado vigente de no registrar antecedentes judiciales – Policía Nacional (no mayor a 30 días).",
  "Certificado de Medidas Correctivas – Policía Nacional (no mayor a 30 días).",
  "Formato único de hoja de vida Función Pública (SIGEP) aprobado según requisitos.",
  "Copia de la libreta militar o certificación provisional (cuando aplique) – contratistas nuevos.",
  "Certificado de sanciones disciplinarias de los respectivos Consejos Profesionales (si aplica).",
  "Examen pre-ocupacional no mayor a 3 años (o 6 meses si servicio de conductor).",
  "Propuesta técnica y económica (si aplica).",
  "Certificado vigente de no estar incurso en procesos de carácter alimentario.",
  "Autorización de consulta de inhabilidad por delitos sexuales (≤30 días).",
  "Declaración de bienes y rentas y conflictos de intereses – Ley 2013 de 2019.",
  "Certificado de compromiso anticorrupción (≤30 días).",
  "Certificado de inhabilidades e incompatibilidades (≤30 días).",
  "Consentimiento informado política de prevención y control de alcohol, tabaco y drogas (≤30 días).",
  "Consentimiento expreso transferencia de datos sensibles – biométricos y declaración.",
  "Contrato de confidencialidad y deber de secreto – Contratista (≤30 días).",
  "Certificado de Experiencia e idoneidad ",
  "Paz y Salvo del Municipio  ",
]
export default function SolicitudAdquisiciones({ necesidadId }) {
  const pageRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [isSaved, setIsSaved] = useState(false);
  const hydratingRef = useRef(false);



  // selector de necesidad (contracts firmados)
  const [necesidadesFirmadas, setNecesidadesFirmadas] = useState([])
  const [searchText, setSearchText] = useState("")
  const [activeNecesidadId, setActiveNecesidadId] = useState(necesidadId || "")
  const [loadingNecesidades, setLoadingNecesidades] = useState(false)
  const [errorNecesidades, setErrorNecesidades] = useState("")

  // Usuario actual (viene desde backend SQL, NO supabase)
  const [currentUser, setCurrentUser] = useState(null)
  const [userSecretaria, setUserSecretaria] = useState("")
  const [userRole, setUserRole] = useState("")

  // Datos base
  const [dependencia, setDependencia] = useState("")
  const [tipoGasto, setTipoGasto] = useState("INVERSION")
  const [budgetItems, setBudgetItems] = useState([])
  const [centroCostos, setCentroCostos] = useState("")
  // Códigos del plan (la "fuente de verdad")
  const [programaCode, setProgramaCode] = useState("")
  const [indicadorCode, setIndicadorCode] = useState("")
  const [bpinCodes, setBpinCodes] = useState([])
  // Campos largos
  const [descripcionNecesidad, setDescripcionNecesidad] = useState("")
  const [objetoContractualAutorizado, setObjetoContractualAutorizado] = useState("")
  const [modalidadContractual, setModalidadContractual] = useState("")
  const [presupuestoAdicional, setPresupuestoAdicional] = useState("")
  const [formaPago, setFormaPago] = useState("")
  const [plazoEjecucion, setPlazoEjecucion] = useState("")
  const [ubicacion, setUbicacion] = useState("")

  // Criterios
  const [personalRequerido, setPersonalRequerido] = useState("")
  const [requisitosIdoneidad, setRequisitosIdoneidad] = useState("")
  const [experienciaPersonaNatural, setExperienciaPersonaNatural] = useState("")
  // Obligaciones / Riesgos
  const [obligacionesGenerales, setObligacionesGenerales] = useState("")
  const [obligacionesContratista, setObligacionesContratista] = useState("")
  const [obligacionesMunicipio, setObligacionesMunicipio] = useState("")
  // Precedentes
  const [precedentes, setPrecedentes] = useState([])
  // Anexos
  const [anexoCDP, setAnexoCDP] = useState("")
  const [anexoRP, setAnexoRP] = useState("")
  // Bloque final
  const [acompTecnico, setAcompTecnico] = useState("")
  const [supervisor, setSupervisor] = useState("")
  const [telefonoFijo, setTelefonoFijo] = useState("604 274 0069") // Teléfono fijo por defecto
  const [telefonoCorreo, setTelefonoCorreo] = useState("")          // Correo electrónico
  const [elaboraNombre, setElaboraNombre] = useState("")
  const [elaboraCargo, setElaboraCargo] = useState("")
  const [elaboraTelefono, setElaboraTelefono] = useState("")        // aquí guardarás la "firma digital"
  // checkbox
  const [requisitosPNChecked, setRequisitosPNChecked] = useState({})

  const [firmaFile, setFirmaFile] = useState(null)
  

  const obtenerNombreArchivoBase = () => {
    const necesidadSeleccionada =
      necesidadesFirmadas.find((n) => n.id === activeNecesidadId) ||
      filteredNecesidades.find((n) => n.id === activeNecesidadId)

    const codigo = necesidadSeleccionada?.codigo || "SIN_CODIGO"

    const limpio = String(codigo)
      .toUpperCase()
      .replace(/\s+/g, "_")
      .replace(/[^A-Z0-9_-]/g, "")

    return `Solicitud_Contratacion_${limpio}`
  }

  const toggleRequisitoPN = (index) => {
    setRequisitosPNChecked((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  const HEADER_META = {
    codigo: "A-CBS-051",
    version: "00",
    fecha: "18-12-2025",
    titulo: "SOLICITUD DE ADQUISICIONES",
  }

  // ===== Mapas nombre por código =====
  const PROGRAMA_MAP = useMemo(
    () => Object.fromEntries((opcionesProgramas || []).map((o) => [o.value, o.label])),
    [],
  )
  const INDICADOR_MAP = useMemo(
    () => Object.fromEntries((opcionesIndicadores || []).map((o) => [o.value, o.label])),
    [],
  )
  const BPIN_MAP = useMemo(
    () => Object.fromEntries((opcionesBPIN || []).map((o) => [o.value, o.label])),
    [],
  )
  const MODALIDAD_MAP = useMemo(
    () => Object.fromEntries((opcionesModalidad || []).map((o) => [o.value, o.label])),
    [],
  )

  // === Helpers parse ===
  const parseBpin = (raw) => {
    if (!raw) return []
    if (Array.isArray(raw)) return raw
    try {
      const j = JSON.parse(raw)
      return Array.isArray(j) ? j : [String(raw)]
    } catch {
      const s = String(raw)
      return s.includes(",")
        ? s
            .split(",")
            .map((x) => x.trim())
            .filter(Boolean)
        : [s.trim()].filter(Boolean)
    }
  }

  const parseCodesCSV = (raw) => {
    if (!raw) return []
    if (Array.isArray(raw)) return raw
    return String(raw)
      .split(",")
      .map((x) => x.trim())
      .filter(Boolean)
  }

  const mapTipoGasto = (tg) => {
    const t = (tg || "")
      .toString()
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
    if (t.includes("FUNCION")) return "FUNCIONAMIENTO"
    if (t.includes("DEUDA")) return "DEUDA"
    return "INVERSION"
  }

  // === Cargar usuario actual desde backend SQL (NO supabase) ===
// ✅ 1) Inicializar usuario (sin depender de authConfig, y soporta varias llaves)
useEffect(() => {
  try {
    // intenta varias llaves típicas
    const stored =
      localStorage.getItem("auth_user") ||
      localStorage.getItem("user") ||
      localStorage.getItem("currentUser");

    if (!stored) {
      console.log("⚠️ No hay usuario autenticado en localStorage");
      setCurrentUser(null);
      setUserRole("");
      setUserSecretaria("");
      return;
    }

    const user = JSON.parse(stored);

    if (!user?.id) {
      console.log("⚠️ El usuario en localStorage no tiene id válido:", user);
      setCurrentUser(null);
      setUserRole("");
      setUserSecretaria("");
      return;
    }

    setCurrentUser(user);

    // roles posibles (ajusta si tus IDs cambian)
    const ROLE_MAP = {
      1: "solicitante",
  2: "planeacion",
  3: "hacienda",
  4: "juridica",
  5: "alcalde",
  6: "administrador",
  7: "presupuesto",
  8: "almacen",
  9: "validador",
  10: "firma_secretario",
  11: "administrador_junior",
};

    const rawRole =
      user.role_id ??
      user.rol_id ??
      user.rolId ??
      user.roleId ??
      user.role ??
      user.rol ??
      user.roleName ??
      "";

    const role =
      typeof rawRole === "number"
        ? ROLE_MAP[rawRole] || ""
        : ROLE_MAP[Number(rawRole)] || String(rawRole || "").toLowerCase();

    setUserRole(role);
    setUserSecretaria(user.secretaria || user.dependencia || "");

    console.log("✅ Usuario autenticado desde localStorage:", user.id, role);
  } catch (err) {
    console.error("❌ Error inicializando usuario desde localStorage:", err);
    setCurrentUser(null);
    setUserRole("");
    setUserSecretaria("");
  }
}, []);

/** === CARGAR CONTRATOS APROBADOS / FIRMADOS COMO "NECESIDADES" (desde SQL vía API) === */
async function loadNecesidadesFirmadas() {
  try {
    setLoadingNecesidades(true)
    setErrorNecesidades("")

    if (!currentUser?.id) {
      console.log("⚠️ loadNecesidadesFirmadas: no hay currentUser.id todavía")
      setNecesidadesFirmadas([])
      return
    }

    const params = new URLSearchParams({
      userId: String(currentUser.id),
      role: userRole || "",
      secretaria: userSecretaria || "",
    })

    const res = await fetch(
      `${API_BASE_URL}/api/adquisiciones/necesidades-firmadas/index.php?${params.toString()}`,
      { credentials: "include" },
    )

    if (!res.ok) {
      const txt = await res.text().catch(() => "")
      throw new Error(
        `No se pudieron cargar las necesidades firmadas (${res.status}). ${txt.slice(0, 160)}`,
      )
    }

    const data = await res.json()

    // ✅ tu endpoint devuelve { ok, items }
    const rows = Array.isArray(data?.items)
      ? data.items
      : Array.isArray(data)
        ? data
        : []

    // ✅ Considerar "firmada/aprobada por alcalde" si:
    // - tiene firma del alcalde (url o campo), O
    // - está en fase 5 (Alcalde), O
    // - el status/estado indica aprobado/firmado
    const soloFirmadas = rows.filter((c) => {
      const fase = Number(c?.current_phase ?? c?.currentPhase ?? 0)
      const status = String(c?.status ?? c?.estado ?? "").toLowerCase()

      const tieneFirmaUrl = !!c?.firma_alcalde_url?.toString().trim()
      const tieneFirmaCampo = !!c?.firma_alcalde?.toString().trim()

      const estaAprobadoPorStatus =
        status.includes("aprob") || status.includes("firm")

      return fase === 5 || tieneFirmaUrl || tieneFirmaCampo || estaAprobadoPorStatus
    })

    const mapped = soloFirmadas.map((c) => ({
      ...c,
      codigo: c.radicado || `ID-${String(c.id).substring(0, 8)}`,
      dependencia: c.secretaria || "Sin dependencia",
    }))

    setNecesidadesFirmadas(mapped)
    console.log(
      `✅ Necesidades firmadas cargadas para ${userRole || "usuario"}:`,
      mapped.length,
    )
  } catch (err) {
    console.error("❌ Error cargando necesidades:", err)
    setErrorNecesidades(
      err?.message || "Error cargando necesidades aprobadas/firmadas.",
    )
    setNecesidadesFirmadas([])
  } finally {
    setLoadingNecesidades(false)
  }
}



/** === CARGAR DATOS DE UNA NECESIDAD (CONTRACT) SELECCIONADA DESDE SQL (vía API) === */
async function cargarDatosDeNecesidad(necesidadIdLocal) {
  if (!necesidadIdLocal) return
  setLoading(true)
  hydratingRef.current = true

  try {
    console.log("🔄 Cargando datos de necesidad ID:", necesidadIdLocal)

    // 1️⃣ CONTRATO BASE (PROD estable)
    const contractUrl = `${API_BASE_URL}/api/contracts/index.php?id=${encodeURIComponent(
      necesidadIdLocal,
    )}`

    const contractRes = await fetch(contractUrl, { credentials: "include" })

    if (!contractRes.ok) {
      const txt = await contractRes.text().catch(() => "")
      throw new Error(`Error cargando contrato: ${contractRes.status} ${txt.slice(0, 160)}`)
    }

    const contractPayload = await contractRes.json()
    const payload = contractPayload?.contract ?? contractPayload?.data ?? contractPayload
    const rows = Array.isArray(payload) ? payload : payload ? [payload] : []

    if (!rows.length) throw new Error("Contrato vacío o no encontrado")

    const contract = rows[0]
    const contractRubros = rows

    console.log("✅ Contrato cargado:", contract)
    console.log("✅ Rubros del contrato:", contractRubros)

    // 2️⃣ SOLICITUD ADQUISICIÓN (puede o no existir)
    const solicitudUrl = `${API_BASE_URL}/api/adquisiciones/solicitud_adquisicion/index.php?necesidad_id=${encodeURIComponent(
      necesidadIdLocal,
    )}`

    const solicitudRes = await fetch(solicitudUrl, { credentials: "include" })

    let solicitud = null
    if (solicitudRes.ok) {
      const p = await solicitudRes.json()
      solicitud = p?.items?.[0] ?? p?.data?.[0] ?? p?.[0] ?? null
      console.log("✅ Solicitud encontrada:", solicitud)
    } else {
      const txt = await solicitudRes.text().catch(() => "")
      console.warn(
        `⚠️ No se pudo cargar solicitud (puede no existir): ${solicitudRes.status} ${txt.slice(0, 160)}`,
      )
    }

    // Helpers
    const safeStr = (v) => (v == null ? "" : String(v)).trim()
    const safeParse = (value, defaultValue = null) => {
      if (!value) return defaultValue
      if (typeof value === "object") return value
      try {
        return JSON.parse(value)
      } catch {
        return defaultValue
      }
    }

    // ✅ Garantiza ARRAY siempre (evita ".map is not a function")
    const normalizeArray = (v) => {
      if (Array.isArray(v)) return v
      if (v == null) return []

      if (typeof v === "object") {
        if (Array.isArray(v.items)) return v.items
        if (Array.isArray(v.data)) return v.data
        return []
      }

      if (typeof v === "string") {
        const s = v.trim()
        if (!s) return []
        try {
          const parsed = JSON.parse(s)
          return normalizeArray(parsed)
        } catch {
          return []
        }
      }

      return []
    }

    // =========================
    // ✅ CASO A: EXISTE SOLICITUD
    // =========================
    if (solicitud && typeof solicitud === "object") {
      console.log("📥 Hidratando desde solicitud guardada...")

      // Jurídica
      if (typeof setDependencia === "function")
        setDependencia(safeStr(solicitud.dependencia || solicitud.secretaria || contract?.secretaria))

      if (typeof setModalidadContractual === "function")
        setModalidadContractual(
          safeStr(
            solicitud.modalidad_contractual ||
              solicitud.modalidad ||
              contract?.modalidad_seleccion ||
              "",
          ),
        )

      // Objeto / Descripción
      if (typeof setObjetoContractualAutorizado === "function")
        setObjetoContractualAutorizado(
          safeStr(
            solicitud.objeto_autorizado_alcalde ||
              solicitud.objeto_contractual ||
              contract?.objeto_contractual,
          ),
        )

      if (typeof setDescripcionNecesidad === "function")
        setDescripcionNecesidad(safeStr(solicitud.descripcion_necesidad || ""))

      // Plan de Desarrollo
      const planMunicipal = safeStr(solicitud.plan_municipal || "")
      if (planMunicipal) {
        const partes = planMunicipal.split(" | ").map((x) => x.trim())
        const prog = partes[0] || ""
        const ind = partes[1] || ""
        const bpin = partes[2] || ""

        if (typeof setProgramaCode === "function" && prog) setProgramaCode(prog)
        if (typeof setIndicadorCode === "function" && ind) setIndicadorCode(ind)
        if (typeof setBpinCodes === "function" && bpin) setBpinCodes(parseBpin(bpin))
      } else {
        if (typeof setProgramaCode === "function" && solicitud.programa) setProgramaCode(safeStr(solicitud.programa))
        if (typeof setIndicadorCode === "function" && solicitud.indicador) setIndicadorCode(safeStr(solicitud.indicador))
       if (typeof setBpinCodes === "function" && solicitud.bpin) setBpinCodes(parseBpin(solicitud.bpin))

      }

      // Naturaleza del gasto (si existe)
      if (typeof setNaturalezaGasto === "function" && solicitud.naturaleza_gasto) {
        setNaturalezaGasto(safeStr(solicitud.naturaleza_gasto))
      }

      // Centro de costos
      if (typeof setCentroCostos === "function")
        setCentroCostos(safeStr(solicitud.centro_costos || contract?.centro_costos || ""))

      // ✅ Presupuesto (NORMALIZADO A ARRAY)
      const presupuestoRaw =
        solicitud.presupuesto_items ??
        solicitud.budget_items ??
        solicitud.items_presupuesto ??
        null

      const presupuestoItems = normalizeArray(presupuestoRaw)

      if (typeof setBudgetItems === "function") {
        if (presupuestoItems.length) {
          setBudgetItems(presupuestoItems)
        } else {
          const rubrosValidos = (contractRubros || []).filter(
            (r) => r?.rubro || r?.discriminacion_rubros,
          )
          const mapped = rubrosValidos.map((r) => ({
            id: crypto?.randomUUID ? crypto.randomUUID() : String(Math.random()),
            resumido: safeStr(r.discriminacion_rubros || ""),
            rubro: safeStr(r.rubro || ""),
            nombreRubro: safeStr(r.nombre_rubro || ""),
            valor: Number(r.valor || 0),
          }))
          setBudgetItems(mapped)
        }
      }

      // ✅ Precedentes (NORMALIZADO A ARRAY)
      const precedentesRaw = solicitud.precedentes ?? solicitud.precedentes_items ?? null
      const precedentesSaved = normalizeArray(precedentesRaw)

      if (typeof setPrecedentes === "function") {
        if (precedentesSaved.length) {
          setPrecedentes(precedentesSaved)
        } else {
          const radicado = safeStr(contract?.radicado || contract?.codigo || "")
          const cc = safeStr(contract?.centro_costos || "")
          const mod = safeStr(contract?.modalidad_seleccion || "")
          const modNum = mod.match(/\d+/)?.[0] || "00"
          const contratoNo = `COPA-${cc}-${modNum}-${radicado}`

          setPrecedentes([
            {
              id: crypto?.randomUUID ? crypto.randomUUID() : String(Math.random()),
              contratoNo,
              objeto: safeStr(contract?.objeto_contractual || "").slice(0, 100),
              valor: Number(contract?.presupuesto_total || 0),
              plazo: safeStr(contract?.duracion_estimada || ""),
            },
          ])
        }
      }

      // Marcadores
      if (typeof setIsSaved === "function") setIsSaved(true)
      if (typeof setNecesidadActiva === "function") setNecesidadActiva({ ...contract, solicitud })

      console.log("✅ Solicitud aplicada al formulario")
      return
    }

    // =============================
    // ✅ CASO B: NO EXISTE SOLICITUD
    // =============================
    console.log("📥 Primera vez: hidratando desde contrato...")

    if (typeof setDependencia === "function") setDependencia(safeStr(contract?.secretaria || ""))
    if (typeof setModalidadContractual === "function")
      setModalidadContractual(safeStr(contract?.modalidad_seleccion || ""))

    if (typeof setObjetoContractualAutorizado === "function")
      setObjetoContractualAutorizado(safeStr(contract?.objeto_contractual || ""))

    if (typeof setDescripcionNecesidad === "function")
      setDescripcionNecesidad(safeStr(contract?.descripcion_necesidad || contract?.descripcion || ""))

    if (typeof setProgramaCode === "function")
      setProgramaCode(safeStr(contract?.programa || contract?.programa_aprobado || ""))

    if (typeof setIndicadorCode === "function")
      setIndicadorCode(safeStr(contract?.indicador || contract?.indicador_aprobado || ""))

    if (typeof setBpinCodes === "function")
      setBpinCodes(safeStr(contract?.bpin || contract?.bpin_aprobado || ""))

    if (typeof setNaturalezaGasto === "function")
      setNaturalezaGasto(safeStr(contract?.naturaleza_gasto || ""))

    if (typeof setCentroCostos === "function")
      setCentroCostos(safeStr(contract?.centro_costos || ""))

    // Presupuesto desde rubros del contrato
    if (typeof setBudgetItems === "function") {
      const rubrosValidos = (contractRubros || []).filter(
        (r) => r?.rubro || r?.discriminacion_rubros,
      )
      const mapped = rubrosValidos.map((r) => ({
        id: crypto?.randomUUID ? crypto.randomUUID() : String(Math.random()),
        resumido: safeStr(r.discriminacion_rubros || ""),
        rubro: safeStr(r.rubro || ""),
        nombreRubro: safeStr(r.nombre_rubro || ""),
        valor: Number(r.valor || 0),
      }))
      setBudgetItems(mapped)
    }

    // Precedentes por defecto
   if (typeof setPrecedentes === "function") {
  const radicado = safeStr(contract?.radicado || contract?.codigo || "")
  const cc = safeStr(contract?.centro_costos || "")
  const mod = safeStr(contract?.modalidad_seleccion || "")
  const modNum = mod.match(/\d+/)?.[0] || "00"
  const contratoNo = `COPA-${cc}-${modNum}-${radicado}`

  setPrecedentes([
    {
      id: crypto?.randomUUID ? crypto.randomUUID() : String(Math.random()),
      contratoNo,
      objeto: safeStr(contract?.objeto_contractual || "").slice(0, 100),
      valor: Number(contract?.presupuesto_total || 0),
      plazo: safeStr(contract?.duracion_estimada || ""),

      // ✅ NUEVOS CAMPOS
      contratoAnteriorNo: "",
      objetoAnterior: "",
      valorAnterior: "",
    },
  ])
}

    if (typeof setIsSaved === "function") setIsSaved(false)
    if (typeof setNecesidadActiva === "function") setNecesidadActiva({ ...contract })

    console.log("✅ Contrato aplicado al formulario")
  } catch (err) {
    console.error("❌ Error:", err)
    alert("Error al cargar datos: " + (err?.message || "Error"))
  } finally {
    setLoading(false)
    setTimeout(() => {
      hydratingRef.current = false
    }, 500)
  }
}
/** === EFECTOS === */
// ✅ 1) Cargar necesidad si viene por prop/parámetro
useEffect(() => {
  if (necesidadId) {
    setActiveNecesidadId(necesidadId);
    cargarDatosDeNecesidad(necesidadId);
  }
}, [necesidadId]);

// ✅ 2) Cargar lista de necesidades firmadas cuando el usuario esté listo
useEffect(() => {
  if (currentUser?.id) {
    loadNecesidadesFirmadas();
  }
}, [currentUser?.id, userRole, userSecretaria]);

// ✅ 3) Debug - Monitorear necesidades cargadas (puedes borrar después)
useEffect(() => {
  console.log("📋 Necesidades firmadas cargadas:", necesidadesFirmadas.length);
  console.log("🎯 Necesidad activa actual:", activeNecesidadId);
}, [necesidadesFirmadas, activeNecesidadId]);

// ✅ 4) Marcar como "no guardado" cuando cambie cualquier campo
//    PERO solo si NO estamos cargando datos iniciales
useEffect(() => {
  if (!activeNecesidadId) return;
  if (hydratingRef.current) return; // ⚠️ No marcar como "no guardado" mientras carga
  
  setIsSaved(false);
}, [
  dependencia,
  tipoGasto,
  centroCostos,
  programaCode,
  indicadorCode,
  JSON.stringify(bpinCodes),
  descripcionNecesidad,
  objetoContractualAutorizado,
  modalidadContractual,
  JSON.stringify(budgetItems),
  presupuestoAdicional,
  formaPago,
  plazoEjecucion,
  ubicacion,
  personalRequerido,
  requisitosIdoneidad,
  experienciaPersonaNatural,
  obligacionesGenerales,
  obligacionesContratista,
  obligacionesMunicipio,
  JSON.stringify(precedentes),
  anexoCDP,
  anexoRP,
  acompTecnico,
  supervisor,
  telefonoFijo,
  telefonoCorreo,
  elaboraNombre,
  elaboraCargo,
  elaboraTelefono,
  firmaFile,
]);

// ✅ 5) Limpiar formulario cuando se deselecciona la necesidad
useEffect(() => {
  if (!activeNecesidadId) {
    // Limpiar todos los campos
    setDependencia("");
    setTipoGasto("INVERSION");
    setBudgetItems([]);
    setCentroCostos("");
    setProgramaCode("");
    setIndicadorCode("");
    setBpinCodes([]);
    setDescripcionNecesidad("");
    setObjetoContractualAutorizado("");
    setModalidadContractual("");
    setPresupuestoAdicional("");
    setFormaPago("");
    setPlazoEjecucion("");
    setUbicacion("");
    setPersonalRequerido("");
    setRequisitosIdoneidad("");
    setExperienciaPersonaNatural("");
    setObligacionesGenerales("");
    setObligacionesContratista("");
    setObligacionesMunicipio("");
    setPrecedentes([]);
    setAnexoCDP("");
    setAnexoRP("");
    setAcompTecnico("");
    setSupervisor("");
    setTelefonoFijo("604 274 0069");
    setTelefonoCorreo("");
    setElaboraNombre("");
    setElaboraCargo("");
    setElaboraTelefono("");
    setFirmaFile(null);
    setRequisitosPNChecked({});
    setIsSaved(false);
  }
}, [activeNecesidadId]);
  const filteredNecesidades = useMemo(() => {
    const term = searchText.trim().toLowerCase()
    if (!term) return necesidadesFirmadas
    return necesidadesFirmadas.filter((n) => {
      const cod = (n.codigo || "").toLowerCase()
      const dep = (n.dependencia || "").toLowerCase()
      return cod.includes(term) || dep.includes(term)
    })
  }, [necesidadesFirmadas, searchText])

  const necesidadSeleccionada = useMemo(
    () => necesidadesFirmadas.find((n) => n.id === activeNecesidadId) || null,
    [necesidadesFirmadas, activeNecesidadId],
  )

  // Nombre base del archivo (para Word y PDF)
  const nombreArchivoBase = useMemo(() => {
    if (!necesidadSeleccionada) {
      return `Solicitud_Contratacion_${activeNecesidadId || "sin_id"}`
    }

    const codigoLimpio = (necesidadSeleccionada.codigo || "")
      .toString()
      .trim()
      .replace(/[^\w\-]+/g, "_")

    return codigoLimpio
      ? `Solicitud_Contratacion_${codigoLimpio}`
      : `Solicitud_Contratacion_${activeNecesidadId || "sin_id"}`
  }, [necesidadSeleccionada, activeNecesidadId])

  // === Mostrar múltiples códigos con nombre ===
  const programaCodes = useMemo(() => parseCodesCSV(programaCode), [programaCode])
  const indicadorCodes = useMemo(() => parseCodesCSV(indicadorCode), [indicadorCode])
  const displayProgramaLines = useMemo(
    () => (programaCodes || []).map((code) => `${code} — ${PROGRAMA_MAP[code] || "Sin nombre"}`),
    [programaCodes, PROGRAMA_MAP],
  )
  const displayIndicadorLines = useMemo(
    () => (indicadorCodes || []).map((code) => `${code} — ${INDICADOR_MAP[code] || "Sin nombre"}`),
    [indicadorCodes, INDICADOR_MAP],
  )
  const displayBpinLines = useMemo(
    () => (bpinCodes || []).map((code) => `${code}${BPIN_MAP[code] ? ` — ${BPIN_MAP[code]}` : ""}`),
    [bpinCodes, BPIN_MAP],
  )
  const displayProgramasJoined = useMemo(() => displayProgramaLines.join(", "), [displayProgramaLines])
  const displayIndicadoresJoined = useMemo(() => displayIndicadorLines.join(", "), [displayIndicadorLines])
  const displayBpinJoined = useMemo(() => displayBpinLines.join(", "), [displayBpinLines])
  const totalPresupuesto = useMemo(
    () => budgetItems.reduce((sum, b) => sum + (Number(b.valor) || 0), 0),
    [budgetItems],
  )

  /** === HANDLERS UI === */
  const addBudgetItem = () =>
    setBudgetItems((arr) => [
      ...arr,
      { id: uuidv4(), resumido: "", rubro: "", nombreRubro: "", valor: 0 },
    ])

  const removeBudgetItem = (id) =>
    setBudgetItems((arr) => arr.filter((x) => x.id !== id))

  const addPrecedente = () =>
  setPrecedentes((arr) => [
    ...arr,
    {
      id: uuidv4(),
      contratoNo: "",
      objeto: "",
      valor: "",
      plazo: "",
      contratoAnteriorNo: "",
      objetoAnterior: "",
      valorAnterior: "",
    },
  ])

  const removePrecedente = (id) =>
    setPrecedentes((arr) => arr.filter((x) => x.id !== id))

 const handleGuardar = async () => {
  if (!activeNecesidadId) {
    alert("Primero selecciona una necesidad firmada.")
    return
  }

  setSaving(true)
  let firmaUrl = elaboraTelefono || ""

  try {
    // 1) Subir firma
    if (firmaFile) {
      const formData = new FormData()
      formData.append("file", firmaFile)
      formData.append("necesidad_id", activeNecesidadId)

      const uploadRes = await fetch(`${API_BASE_URL}/api/firmas/upload/index.php`, {
        method: "POST",
        body: formData,
        credentials: "include",
      })

      if (!uploadRes.ok) {
        throw new Error(`Error subiendo firma: ${uploadRes.status}`)
      }

      const uploadData = await uploadRes.json()
      firmaUrl = uploadData?.url || uploadData?.data?.url || ""

      if (!firmaUrl) {
        throw new Error("No se obtuvo URL de firma")
      }
    }

    // 2) Plan municipal
    const planMunicipalTexto = [
      displayProgramasJoined,
      displayIndicadoresJoined,
      displayBpinJoined,
    ].filter(Boolean).join(" | ")

    // 3) Payload
    const payload = {
      necesidad_id: activeNecesidadId,
      dependencia: dependencia || "",
      plan_municipal: planMunicipalTexto || "",
      tipo_gasto: tipoGasto || "INVERSION",
      descripcion_necesidad: descripcionNecesidad || "",
      objeto_autorizado_alcalde: objetoContractualAutorizado || "",
      modalidad_contractual: modalidadContractual || "",
      presupuesto_cuadro: JSON.stringify(budgetItems),
      presupuesto_adicional: presupuestoAdicional || "",
      forma_pago: formaPago || "",
      plazo_ejecucion: plazoEjecucion || "",
      centro_costos: centroCostos || "",
      ubicacion: ubicacion || "Municipio de Copacabana - Antioquia",
      criterios: JSON.stringify({
        personalRequerido: personalRequerido || "",
        requisitosIdoneidad: requisitosIdoneidad || "",
        experienciaPersonaNatural: experienciaPersonaNatural || "",
      }),
      obligaciones_generales: obligacionesGenerales || "",
      obligaciones_contratista: obligacionesContratista || "",
      obligaciones_municipio: obligacionesMunicipio || "",
      precedentes: JSON.stringify(precedentes),
      anexos: JSON.stringify({ cdp: anexoCDP || "", rp: anexoRP || "" }),
      bloque_final: JSON.stringify({
        acompTecnico: acompTecnico || "",
        supervisor: supervisor || "",
        telefonoFijo: telefonoFijo || "604 274 0069",
        telefonoCorreo: telefonoCorreo || "",
        elaboraNombre: elaboraNombre || "",
        elaboraCargo: elaboraCargo || "",
        elaboraTelefono: firmaUrl || "",
      }),
    }

    console.log("📤 Enviando:", payload)

    // 4) Enviar
    const saveRes = await fetch(`${API_BASE_URL}/api/adquisiciones/solicitud_adquisicion/index.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      credentials: "include",
    })

    if (!saveRes.ok) {
      const txt = await saveRes.text()
      throw new Error(`Error ${saveRes.status}: ${txt}`)
    }

    console.log("✅ Guardado exitoso")

    setIsSaved(true)
    setElaboraTelefono(firmaUrl)
    setFirmaFile(null)

    alert("✅ Información guardada")
  } catch (e) {
    console.error("❌ Error:", e)
    alert("❌ Error: " + e.message)
  } finally {
    setSaving(false)
  }
}

  const handleBack = () => {
    if (window.history.length > 1) window.history.back()
    else window.location.href = "/"
  }

  /** ====== HELPERS DOCX ====== */
  const H2 = (text) =>
    new Paragraph({
      children: [new TextRun({ text, bold: true, color: "FFFFFF" })],
      shading: { type: "clear", color: "auto", fill: BLUE },
      spacing: { before: 200, after: 120 },
      alignment: AlignmentType.LEFT,
    })

  const P = (text) => new Paragraph({ children: [new TextRun(text || "")] })

  const PB = (text) => new Paragraph({ children: [new TextRun({ text, bold: true })] })

  const table = (rows, widths = [], headerRowCount = 0) =>
    new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      borders: {
        top: { style: BorderStyle.SINGLE, size: 4, color: GRAY_BORDER },
        left: { style: BorderStyle.SINGLE, size: 4, color: GRAY_BORDER },
        bottom: { style: BorderStyle.SINGLE, size: 4, color: GRAY_BORDER },
        right: { style: BorderStyle.SINGLE, size: 4, color: GRAY_BORDER },
        insideHorizontal: { style: BorderStyle.SINGLE, size: 2, color: GRAY_BORDER },
        insideVertical: { style: BorderStyle.SINGLE, size: 2, color: GRAY_BORDER },
      },
      rows: rows.map(
        (cells, rIdx) =>
          new TableRow({
            tableHeader: rIdx < headerRowCount,
            children: cells.map(
              (cell, cIdx) =>
                new TableCell({
                  width: widths[cIdx]
                    ? { type: WidthType.PERCENTAGE, size: widths[cIdx] }
                    : undefined,
                  children: [typeof cell === "string" ? P(cell) : cell],
                  shading:
                    rIdx < headerRowCount
                      ? { type: "clear", color: "auto", fill: BLUE_SOFT }
                      : undefined,
                }),
            ),
          }),
      ),
    })

  const fetchImageBytes = async (url) => {
    try {
      const res = await fetch(url)
      const blob = await res.blob()
      const ab = await blob.arrayBuffer()
      return new Uint8Array(ab)
    } catch {
      return null
    }
  }

  const buildWordHeaderBlue = (logoBytes) =>
    new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      borders: {
        top: { style: BorderStyle.SINGLE, size: 6, color: BLUE },
        left: { style: BorderStyle.SINGLE, size: 6, color: BLUE },
        bottom: { style: BorderStyle.SINGLE, size: 6, color: BLUE },
        right: { style: BorderStyle.SINGLE, size: 6, color: BLUE },
        insideHorizontal: { style: BorderStyle.SINGLE, size: 2, color: "FFFFFF" },
        insideVertical: { style: BorderStyle.SINGLE, size: 2, color: "FFFFFF" },
      },
      rows: [
        new TableRow({
          children: [
            new TableCell({
              width: { type: WidthType.PERCENTAGE, size: 35 },
              shading: { type: "clear", color: "auto", fill: BLUE },
              verticalAlign: VerticalAlign.CENTER,
              margins: { top: 200, bottom: 200, left: 200, right: 200 },
              children: [
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: logoBytes
                    ? [new ImageRun({ data: logoBytes, transformation: { width: 70, height: 70 } })]
                    : [new TextRun({ text: " ", size: 2 })],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Alcaldía de",
                      bold: true,
                      color: "FFFFFF",
                      size: 28,
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: "Copacabana",
                      bold: true,
                      color: "FFFFFF",
                      size: 28,
                    }),
                  ],
                }),
              ],
            }),
            new TableCell({
              width: { type: WidthType.PERCENTAGE, size: 40 },
              shading: { type: "clear", color: "auto", fill: BLUE },
              verticalAlign: VerticalAlign.CENTER,
              margins: { top: 200, bottom: 200, left: 200, right: 200 },
              children: [
                new Paragraph({
                  alignment: AlignmentType.LEFT,
                  children: [
                    new TextRun({
                      text: HEADER_META.titulo,
                      bold: true,
                      color: "FFFFFF",
                      size: 28,
                    }),
                  ],
                }),
              ],
            }),
            new TableCell({
              width: { type: WidthType.PERCENTAGE, size: 25 },
              shading: { type: "clear", color: "auto", fill: BLUE },
              verticalAlign: VerticalAlign.CENTER,
              margins: { top: 200, bottom: 200, left: 200, right: 200 },
              children: [
                new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `Código: ${HEADER_META.codigo}`,
                      color: "FFFFFF",
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `Versión: ${HEADER_META.version}`,
                      color: "FFFFFF",
                    }),
                  ],
                }),
                new Paragraph({
                  alignment: AlignmentType.RIGHT,
                  children: [
                    new TextRun({
                      text: `Fecha Actualización: ${HEADER_META.fecha}`,
                      color: "FFFFFF",
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
      ],
    })

  const handleDownloadWord = async () => {
    if (!activeNecesidadId) {
  alert("Primero selecciona una necesidad firmada.");
  return;
}
if (!isSaved) {
  alert("Antes de descargar debes Guardar la información.");
  return;
}
    try {
      console.log("🔄 Iniciando generación de documento...")

      // 1. Cargar el logo como bytes para docx
      let logoBytes
      try {
        const res = await fetch(logoHeader)
        if (res.ok) {
          const buffer = await res.arrayBuffer()
          logoBytes = new Uint8Array(buffer)
          console.log("✅ Logo cargado exitosamente:", logoBytes.length, "bytes")
        } else {
          console.error("❌ No se pudo obtener el logo para el Word:", res.status, res.statusText)
        }
      } catch (err) {
        console.error("❌ Error cargando el logo para Word:", err)
      }

      // 2. Construir el documento
      const doc = new Document({
        creator: "Sistema de Necesidades",
        description: "Solicitud de Contratación",
        styles: {
          default: {
            document: {
              run: { font: "Arial", size: 22 },
              paragraph: { spacing: { after: 120 } },
            },
          },
        },
        sections: [
          {
            properties: {
              page: {
                margin: { top: 1440, right: 1440, bottom: 1440, left: 1440 },
                borders: {
                  pageBorderTop: {
                    style: BorderStyle.SINGLE,
                    size: 24,
                    color: BLUE,
                    space: 24,
                  },
                  pageBorderLeft: {
                    style: BorderStyle.SINGLE,
                    size: 24,
                    color: BLUE,
                    space: 24,
                  },
                  pageBorderBottom: {
                    style: BorderStyle.SINGLE,
                    size: 24,
                    color: BLUE,
                    space: 24,
                  },
                  pageBorderRight: {
                    style: BorderStyle.SINGLE,
                    size: 24,
                    color: BLUE,
                    space: 24,
                  },
                },
              },
            },
            children: [
              buildWordHeaderBlue(logoBytes),
              new Paragraph(""),
              H2("Dependencia"),
              P(dependencia),
              H2("Descripción de la necesidad"),
              P(descripcionNecesidad),
              H2("Objeto contractual (autorizado por Alcalde)"),
              P(objetoContractualAutorizado),
              H2("Modalidad contractual"),
              P(
                modalidadContractual
                  ? `${modalidadContractual} — ${MODALIDAD_MAP[modalidadContractual] || ""}`
                  : modalidadContractual,
              ),
              H2("Datos del proyecto – Información Plan de Desarrollo Municipal"),
              table(
                [
                  [PB("Programa"), P(displayProgramaLines.length ? displayProgramaLines.join("\n") : "-")],
                  [PB("Indicador"), P(displayIndicadorLines.length ? displayIndicadorLines.join("\n") : "-")],
                  [PB("BPIN"), P(displayBpinLines.length ? displayBpinLines.join("\n") : "-")],
                ],
                [20, 80],
                0,
              ),
              H2("Información Presupuestal"),
              table(
                [
                  [PB("RESUMIDO"), PB("RUBRO"), PB("NOMBRE RUBRO"), PB("VALOR")],
                  ...budgetItems.map((b) => [
                    P(b.resumido || ""),
                    P(b.rubro || ""),
                    P(b.nombreRubro || ""),
                    P(CURRENCY.format(Number(b.valor) || 0)),
                  ]),
                  [P(""), P(""), PB("TOTAL"), P(CURRENCY.format(totalPresupuesto))],
                ],
                [15, 35, 35, 15],
                1,
              ),
              P(" "),
              P(presupuestoAdicional),
              H2("Tipo de gasto"),
              P(
                tipoGasto === "INVERSION"
                  ? "Inversión"
                  : tipoGasto === "FUNCIONAMIENTO"
                    ? "Funcionamiento"
                    : "Deuda pública",
              ),
              H2("Centro de costos"),
              P(centroCostos),
              H2("Forma de pago"),
              P(formaPago),
              H2("Plazo de ejecución"),
              P(plazoEjecucion),
              H2("Ubicación"),
              P("Municipio de Copacabana - Antioquia"),
              H2("9. Criterios para la selección del contratista"),
              PB("• Personal requerido"),
              P(personalRequerido),
              PB("• Requisitos de idoneidad"),
              P(requisitosIdoneidad),
              PB("• Requisitos de experiencia – Persona natural"),
              P(experienciaPersonaNatural),
              H2("10. Requisitos legales – Persona natural (informativo)"),
              ...REQUISITOS_LEGALES_PN.map((t) => P(`• ${t}`)),
              H2("11. Obligaciones Generales"),
              P(obligacionesGenerales),
              PB("11.1 Obligaciones específicas del contratista"),
              P(obligacionesContratista),
              PB("11.2 Obligaciones específicas del municipio"),
              P(obligacionesMunicipio),
             H2("12. Precedente contractual"),
table(
  [
    [
      PB("Contrato No."),
      PB("Objeto"),
      PB("Valor"),
      PB("Plazo"),
      PB("Número contrato anterior"),
      PB("Objeto anterior"),
      PB("Valor anterior"),
    ],
    ...(precedentes.length
      ? precedentes.map((p) => [
          P(p.contratoNo || "-"),
          P(p.objeto || "-"),
          P(p.valor || "-"),
          P(p.plazo || "-"),
          P(p.contratoAnteriorNo || "-"),
          P(p.objetoAnterior || "-"),
          P(p.valorAnterior || "-"),
        ])
      : [[P("-"), P("-"), P("-"), P("-"), P("-"), P("-"), P("-")]]),
  ],
  [14, 30, 10, 10, 12, 16, 8],
  1,
),
              H2("13. Anexos "),
              table(
                [
                  [PB("CDP (número/enlace)"), P(anexoCDP || "-")],
                ],
                [35, 65],
                1,
              ),
              H2("Información final"),
              table(
                [
                  [PB("Acompañamiento técnico"), P(acompTecnico)],
                  [PB("Supervisor"), P(supervisor)],
                  [PB("Teléfono y correo electrónico"), P(telefonoCorreo)],
                  [PB("Nombre de quien elabora la solicitud"), P(elaboraNombre)],
                  [PB("Cargo"), P(elaboraCargo)],
                  [PB("Teléfono"), P(elaboraTelefono)],
                ],
                [40, 60],
                0,
              ),
            ],
          },
        ],
      })

      const blob = await Packer.toBlob(doc)
      const url = URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = `${nombreArchivoBase}.docx`
      a.click()
      setTimeout(() => URL.revokeObjectURL(url), 1200)

      console.log("✅ Documento Word generado")
    } catch (e) {
      console.error("❌ Error generando documento:", e)
      alert("No se pudo generar el documento Word: " + e.message)
    }
  }

  const handleDownloadPDF = async () => {
    try {
      if (!pageRef.current) {
        alert("No se encontró el contenido para generar el PDF.")
        return
      }

      if (!activeNecesidadId) {
        alert("Primero selecciona una necesidad firmada.")
        return
      }

      setLoading(true)
      console.log("Iniciando generación de PDF...")

      const nombreArchivoBase = obtenerNombreArchivoBase()
      const element = pageRef.current

      const originalTransform = element.style.transform
      const originalTransformOrigin = element.style.transformOrigin
      const originalWidth = element.style.width
      const originalMargin = element.style.margin

      element.style.transform = "scale(0.8)"
      element.style.transformOrigin = "top left"
      element.style.width = "900px"
      element.style.margin = "0"

      const opt = {
        margin: [10, 10, 10, 10],
        filename: `${nombreArchivoBase}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          scrollX: 0,
          scrollY: 0,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
        pagebreak: {
          mode: ["css", "legacy"],
        },
      }

      await html2pdf().set(opt).from(element).save()

      element.style.transform = originalTransform
      element.style.transformOrigin = originalTransformOrigin
      element.style.width = originalWidth
      element.style.margin = originalMargin

      console.log("PDF generado correctamente.")
    } catch (error) {
      console.error("Error generando PDF:", error)
      alert("No se pudo generar el PDF: " + error.message)
    } finally {
      setLoading(false)
    }
  }

  /** ====== RENDER ====== */
  return (
    <div ref={pageRef} style={styles.page}>
      <div style={styles.topbar}>
        <div style={styles.topbarInner}>
          <h1 style={styles.h1}>NECESIDADES DE CONTRATACIÓN - SOLICITUD DE ADQUISICIONES</h1>
        </div>
      </div>
      <div style={styles.container}>
        {/* Header con logo y metadata */}
        <div style={styles.card}>
          <div
            style={{
              padding: 16,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 16,
            }}
          >
            <img
              src={logoHeader || "/placeholder.svg"}
              alt="Logo"
              style={{
                width: 200,
                height: 200,
                objectFit: "contain",
              }}
            />
            <div style={{ flex: 1, textAlign: "center" }}>
              <div style={{ fontSize: 30, fontWeight: 600 }}>{HEADER_META.titulo}</div>
            </div>
            <div style={{ fontSize: 12, textAlign: "right" }}>
              <div>Código: {HEADER_META.codigo}</div>
              <div>Versión: {HEADER_META.version}</div>
              <div>Fecha: {HEADER_META.fecha}</div>
            </div>
          </div>
        </div>

        <div style={styles.topActionsRow}>
  <button onClick={handleBack} style={{ ...styles.btn, ...styles.btnGhost }}>
    ← Regresar
  </button>
</div>

        {/* Selección de necesidad firmada */}
        <Section title="Seleccionar necesidad firmada">
          <div style={styles.formRow}>
            <label style={styles.label}>Buscar necesidad</label>
            <input
              style={styles.input}
              placeholder="Ej. 0001-2026 o parte del texto"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <div style={styles.formRow}>
            <label style={styles.label}>Necesidad</label>
            <select
              style={styles.input}
              value={activeNecesidadId || ""}
              onChange={(e) => {
                const id = e.target.value || ""
                setActiveNecesidadId(id)
                if (id) cargarDatosDeNecesidad(id)
              }}
            >
              <option value="">— Seleccione una necesidad firmada —</option>
              {filteredNecesidades.map((n) => (
                <option key={n.id} value={n.id}>
                  {n.codigo} — {n.dependencia}
                </option>
              ))}
            </select>
          </div>
          <p style={{ fontSize: 12, color: "#4b5563", marginTop: 4 }}>
            Solo se muestran necesidades (contracts) que ya aparecen aprobadas / firmadas por el Alcalde.
          </p>
          <p style={{ fontSize: 12, color: "#4b5563", marginTop: 2 }}>
            Necesidades cargadas: {necesidadesFirmadas.length}
          </p>
          {loadingNecesidades && (
            <p style={{ fontSize: 12, color: "#2563eb", marginTop: 4 }}>Cargando necesidades firmadas…</p>
          )}
          {errorNecesidades && (
            <p style={{ fontSize: 12, color: "#b91c1c", marginTop: 4 }}>
              Error al cargar necesidades: {errorNecesidades}
            </p>
          )}
          {!loadingNecesidades && !errorNecesidades && necesidadesFirmadas.length === 0 && (
            <p style={{ fontSize: 12, color: "#b91c1c", marginTop: 4 }}>
              No se encontraron registros en la tabla <strong>contracts</strong> con aprobación del Alcalde.
            </p>
          )}
        </Section>

        {/* Información jurídica */}
        <Section title="Información jurídica">
          <div style={styles.formRow}>
            <label style={styles.label}>Dependencia</label>
            <input style={styles.input} value={dependencia} onChange={(e) => setDependencia(e.target.value)} />
          </div>
          <div style={styles.formRow}>
            <label style={styles.label}>Modalidad contractual </label>
            <div>
              <textarea
                style={{ ...styles.textarea, background: "#fafafa" }}
                rows={3}
                readOnly
                value={modalidadContractual}
              />
              <div style={styles.hint}>Campo generado automáticamente desde la necesidad seleccionada</div>
            </div>
          </div>
          <div style={styles.formRow}>
            <label style={styles.label}>Objeto contractual </label>
            <textarea
              style={styles.textarea}
              rows={4}
              value={objetoContractualAutorizado}
              onChange={(e) => setObjetoContractualAutorizado(e.target.value)}
            />
          </div>
          <div style={styles.formRow}>
            <label style={styles.label}>Descripción de la necesidad </label>
            <div>
              <textarea
                style={styles.textarea}
                rows={6}
                maxLength={MAX_8K}
                value={descripcionNecesidad}
                onChange={(e) => setDescripcionNecesidad(e.target.value)}
              />
              <div style={styles.hint}>
                {descripcionNecesidad.length}/{MAX_8K}
              </div>
            </div>
          </div>
        </Section>

        {/* Plan de desarrollo municipal */}
        <Section title="Información Plan de Desarrollo Municipal">
          <div style={styles.formRow}>
            <label style={styles.label}>Programa</label>
            <textarea
              style={{ ...styles.textarea, background: "#fafafa" }}
              rows={Math.max(2, displayProgramaLines.length || 2)}
              readOnly
              value={displayProgramaLines.join("\n")}
            />
          </div>
          <div style={styles.formRow}>
            <label style={styles.label}>Indicador</label>
            <textarea
              style={{ ...styles.textarea, background: "#fafafa" }}
              rows={Math.max(2, displayIndicadorLines.length || 2)}
              readOnly
              value={displayIndicadorLines.join("\n")}
            />
          </div>
          <div style={styles.formRow}>
            <label style={styles.label}>BPIN</label>
            <textarea
              style={{ ...styles.textarea, background: "#fafafa" }}
              rows={Math.max(2, displayBpinLines.length || 2)}
              readOnly
              value={displayBpinLines.length ? displayBpinLines.join("\n") : ""}
            />
          </div>
        </Section>

        {/* Información presupuestal */}
        <Section
          title="Información Presupuestal"
          right={<InfoPill right={`Presupuesto Total: ${CURRENCY.format(totalPresupuesto)}`}>Resumen</InfoPill>}
        >
          <div style={styles.tableWrap}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>RESUMIDO</th>
                  <th style={styles.th}>RUBRO</th>
                  <th style={styles.th}>NOMBRE RUBRO</th>
                  <th style={{ ...styles.th, textAlign: "right" }}>VALOR</th>
                  <th style={styles.th}></th>
                </tr>
              </thead>
              <tbody>
                {budgetItems.map((b) => (
                  <tr key={b.id}>
                    <td style={styles.td}>
                      <input
                        style={styles.input}
                        value={b.resumido}
                        onChange={(e) =>
                          setBudgetItems((arr) =>
                            arr.map((x) => (x.id === b.id ? { ...x, resumido: e.target.value } : x)),
                          )
                        }
                      />
                    </td>
                    <td style={styles.td}>
                      <textarea
                        style={styles.textarea}
                        rows={2}
                        value={b.rubro}
                        onChange={(e) =>
                          setBudgetItems((arr) =>
                            arr.map((x) => (x.id === b.id ? { ...x, rubro: e.target.value } : x)),
                          )
                        }
                      />
                    </td>
                    <td style={styles.td}>
                      <textarea
                        style={styles.textarea}
                        rows={2}
                        value={b.nombreRubro}
                        onChange={(e) =>
                          setBudgetItems((arr) =>
                            arr.map((x) =>
                              x.id === b.id ? { ...x, nombreRubro: e.target.value } : x,
                            ),
                          )
                        }
                      />
                    </td>
                    <td style={styles.tdRight}>
                      <input
                        type="number"
                        style={{ ...styles.input, textAlign: "right" }}
                        value={b.valor}
                        onChange={(e) =>
                          setBudgetItems((arr) =>
                            arr.map((x) => (x.id === b.id ? { ...x, valor: Number(e.target.value || 0) } : x)),
                          )
                        }
                      />
                    </td>
                    <td style={{ ...styles.td, textAlign: "center" }}>
                      <button style={styles.btnOutline} onClick={() => removeBudgetItem(b.id)}>
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td style={{ ...styles.tdRight, fontWeight: 700 }} colSpan={3}>
                    TOTAL
                  </td>
                  <td style={{ ...styles.tdRight, fontWeight: 700 }}>
                    {CURRENCY.format(totalPresupuesto)}
                  </td>
                  <td style={styles.td} />
                </tr>
              </tbody>
            </table>
          </div>

          <div style={{ ...styles.formRow, alignItems: "center" }}>
            <label style={styles.label}>Tipo Naturaleza</label>
            <div style={{ display: "flex", gap: 20 }}>
              <label>
                <input
                  type="radio"
                  name="tipoGasto"
                  checked={tipoGasto === "INVERSION"}
                  onChange={() => setTipoGasto("INVERSION")}
                />{" "}
                Inversión
              </label>
              <label>
                <input
                  type="radio"
                  name="tipoGasto"
                  checked={tipoGasto === "FUNCIONAMIENTO"}
                  onChange={() => setTipoGasto("FUNCIONAMIENTO")}
                />{" "}
                Funcionamiento
              </label>
              <label>
                <input
                  type="radio"
                  name="tipoGasto"
                  checked={tipoGasto === "DEUDA"}
                  onChange={() => setTipoGasto("DEUDA")}
                />{" "}
                Deuda pública
              </label>
            </div>
          </div>

          <div style={styles.formRow}>
            <label style={styles.label}>Centro de costos</label>
            <input
              style={styles.input}
              value={centroCostos}
              onChange={(e) => setCentroCostos(e.target.value)}
              placeholder="Ej. 2025-ADM-PLANEACION"
            />
          </div>
        </Section>

        {/* Condiciones del contrato */}
        <Section title="Condiciones del contrato">
          <div
            style={{
              display: "grid",
              gap: 16,
              gridTemplateColumns: "repeat(2, 1fr)",
            }}
          >
            <div>
              <div style={styles.label}>Forma de pago</div>
              <textarea
                style={styles.textarea}
                rows={4}
                maxLength={MAX_1K}
                value={formaPago}
                onChange={(e) => setFormaPago(e.target.value)}
                placeholder="Escribe aquí la forma de pago…"
              />
              <div style={styles.hint}>
                {formaPago.length}/{MAX_1K}
              </div>
            </div>

            <div>
              <div style={styles.label}>Plazo de ejecución</div>
              <textarea
                style={styles.textarea}
                rows={4}
                maxLength={MAX_2K}
                value={plazoEjecucion}
                onChange={(e) => setPlazoEjecucion(e.target.value)}
                placeholder="Escribe aquí el plazo de ejecución…"
              />
              <div style={styles.hint}>
                {plazoEjecucion.length}/{MAX_2K}
              </div>
            </div>
          </div>
        </Section>

        {/* Criterios */}
        <Section title="9. Criterios para la selección del contratista">
          <div
            style={{
              display: "grid",
              gap: 16,
              gridTemplateColumns: "repeat(2, 1fr)",
            }}
          >
            <div>
              <div style={styles.label}>Personal requerido</div>
              <textarea
                style={styles.textarea}
                rows={4}
                value={personalRequerido}
                onChange={(e) => setPersonalRequerido(e.target.value)}
              />
            </div>
            <div>
              <div style={styles.label}>Requisitos de idoneidad</div>
              <textarea
                style={styles.textarea}
                rows={4}
                value={requisitosIdoneidad}
                onChange={(e) => setRequisitosIdoneidad(e.target.value)}
              />
            </div>
          </div>
          <div style={{ marginTop: 16 }}>
            <div style={styles.label}>Requisitos de experiencia – Persona natural</div>
            <textarea
              style={styles.textarea}
              rows={4}
              value={experienciaPersonaNatural}
              onChange={(e) => setExperienciaPersonaNatural(e.target.value)}
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <div
              style={{
                fontWeight: 600,
                marginBottom: 8,
                fontSize: 14,
              }}
            >
              Listado informativo de soportes (marque los que se aportan)
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {REQUISITOS_LEGALES_PN.map((texto, index) => (
                <label
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 8,
                    fontSize: 14,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={!!requisitosPNChecked[index]}
                    onChange={() => toggleRequisitoPN(index)}
                  />
                  <span>{texto}</span>
                </label>
              ))}
            </div>
          </div>
        </Section>

        {/* Obligaciones  */}
        <Section title="11. Obligaciones ">
          <div>
            <div style={styles.label}>11. Obligaciones Generales </div>
            <textarea
              style={styles.textarea}
              rows={8}
              maxLength={MAX_10K}
              value={obligacionesGenerales}
              onChange={(e) => setObligacionesGenerales(e.target.value)}
            />
            <div style={styles.hint}>
              {obligacionesGenerales.length}/{MAX_10K}
            </div>
          </div>
          <div style={{ marginTop: 16 }}>
            <div style={styles.label}>11.1 Obligaciones específicas del contratista </div>
            <textarea
              style={styles.textarea}
              rows={8}
              maxLength={MAX_10K}
              value={obligacionesContratista}
              onChange={(e) => setObligacionesContratista(e.target.value)}
            />
            <div style={styles.hint}>
              {obligacionesContratista.length}/{MAX_10K}
            </div>
          </div>
          <div style={{ marginTop: 16 }}>
            <div style={styles.label}>11.2 Obligaciones específicas del municipio </div>
            <textarea
              style={styles.textarea}
              rows={4}
              maxLength={MAX_1K}
              value={obligacionesMunicipio}
              onChange={(e) => setObligacionesMunicipio(e.target.value)}
            />
            <div style={styles.hint}>
              {obligacionesMunicipio.length}/{MAX_1K}
            </div>
          </div>
      </Section>

      {/* Precedente contractual */}
      <Section
        title="12. Precedente contractual"
        right={
          <button
            onClick={addPrecedente}
            style={{
              ...styles.btn,
              background: "#ffffff",
              border: "1px solid #fff",
              color: "#fff",
              opacity: 0.9,
            }}
          >
            Agregar fila
          </button>
        }
      >
       <div style={styles.tableWrap}>
  <table style={styles.table}>
    <thead>
      <tr>
        <th style={styles.th}>Contrato No.</th>
        <th style={styles.th}>Objeto</th>
        <th style={styles.th}>Valor</th>
        <th style={styles.th}>Plazo</th>

        {/* ✅ NUEVOS CAJONES */}
        <th style={styles.th}>Número contrato anterior</th>
        <th style={styles.th}>Objeto anterior</th>
        <th style={styles.th}>Valor anterior</th>

        <th style={styles.th}></th>
      </tr>
    </thead>

    <tbody>
      {precedentes.map((p) => (
        <tr key={p.id}>
          <td style={styles.td}>
            <input
              style={styles.input}
              value={p.contratoNo || ""}
              onChange={(e) =>
                setPrecedentes((arr) =>
                  arr.map((x) => (x.id === p.id ? { ...x, contratoNo: e.target.value } : x)),
                )
              }
            />
          </td>

          <td style={styles.td}>
            <textarea
              style={styles.textarea}
              rows={2}
              value={p.objeto || ""}
              onChange={(e) =>
                setPrecedentes((arr) =>
                  arr.map((x) => (x.id === p.id ? { ...x, objeto: e.target.value } : x)),
                )
              }
            />
          </td>

          <td style={styles.td}>
            <input
              style={styles.input}
              value={p.valor || ""}
              onChange={(e) =>
                setPrecedentes((arr) =>
                  arr.map((x) => (x.id === p.id ? { ...x, valor: e.target.value } : x)),
                )
              }
            />
          </td>

          <td style={styles.td}>
            <input
              style={styles.input}
              value={p.plazo || ""}
              onChange={(e) =>
                setPrecedentes((arr) =>
                  arr.map((x) => (x.id === p.id ? { ...x, plazo: e.target.value } : x)),
                )
              }
            />
          </td>

          {/* ✅ NUEVOS CAMPOS POR FILA */}
          <td style={styles.td}>
            <input
              style={styles.input}
              value={p.contratoAnteriorNo || ""}
              onChange={(e) =>
                setPrecedentes((arr) =>
                  arr.map((x) =>
                    x.id === p.id ? { ...x, contratoAnteriorNo: e.target.value } : x,
                  ),
                )
              }
            />
          </td>

          <td style={styles.td}>
            <textarea
              style={styles.textarea}
              rows={2}
              value={p.objetoAnterior || ""}
              onChange={(e) =>
                setPrecedentes((arr) =>
                  arr.map((x) => (x.id === p.id ? { ...x, objetoAnterior: e.target.value } : x)),
                )
              }
            />
          </td>

          <td style={styles.td}>
            <input
              style={styles.input}
              value={p.valorAnterior || ""}
              onChange={(e) =>
                setPrecedentes((arr) =>
                  arr.map((x) => (x.id === p.id ? { ...x, valorAnterior: e.target.value } : x)),
                )
              }
            />
          </td>

          <td style={{ ...styles.td, textAlign: "center" }}>
            <button style={styles.btnOutline} onClick={() => removePrecedente(p.id)}>
              Eliminar
            </button>
          </td>
        </tr>
      ))}

      {precedentes.length === 0 && (
        <tr>
          <td
            style={{
              ...styles.td,
              textAlign: "center",
              color: "#6b7280",
            }}
            colSpan={8}
          >
            No has agregado precedentes.
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

      </Section>

      {/* Anexos */}
      <Section title="13. Anexos  ">
        <div style={styles.formRow}>
          <label style={styles.label}>CDP </label>
          <input style={styles.input} value={anexoCDP} onChange={(e) => setAnexoCDP(e.target.value)} />
        </div>
      </Section>

      {/* Info final */}
      <Section title="Información final">
        <div
          style={{
            display: "grid",
            gap: 16,
            gridTemplateColumns: "repeat(2, 1fr)",
          }}
        >
          <div>
            <div style={styles.label}>Acompañamiento técnico</div>
            <input
              style={styles.input}
              value={acompTecnico}
              onChange={(e) => setAcompTecnico(e.target.value)}
            />
          </div>

          <div>
            <div style={styles.label}>Supervisor</div>
            <input
              style={styles.input}
              value={supervisor}
              onChange={(e) => setSupervisor(e.target.value)}
            />
          </div>

          <div>
            <div style={styles.label}>Teléfono fijo</div>
            <input
              style={styles.input}
              value={telefonoFijo}
              onChange={(e) => setTelefonoFijo(e.target.value)}
            />
          </div>

          <div>
            <div style={styles.label}>Correo electrónico</div>
            <input
              style={styles.input}
              value={telefonoCorreo}
              onChange={(e) => setTelefonoCorreo(e.target.value)}
            />
          </div>
        </div>

        <div style={{ marginTop: 16 }}>
          <div style={styles.label}>Elabora la solicitud</div>
          <div
            style={{
              display: "grid",
              gap: 16,
              gridTemplateColumns: "repeat(3, 1fr)",
            }}
          >
            <div>
              <div style={styles.label}>Nombre</div>
              <input
                style={styles.input}
                value={elaboraNombre}
                onChange={(e) => setElaboraNombre(e.target.value)}
              />
            </div>

            <div>
              <div style={styles.label}>Cargo</div>
              <input
                style={styles.input}
                value={elaboraCargo}
                onChange={(e) => setElaboraCargo(e.target.value)}
              />
            </div>

            <div>
              <div style={styles.label}>Firma digital</div>
              <input
                type="file"
                accept=".pdf,.png,.jpg,.jpeg"
                style={styles.input}
                onChange={(e) => {
                  const file = e.target.files?.[0] || null
                  setFirmaFile(file)
                }}
              />
              {elaboraTelefono && (
                <div style={styles.hint}>
                  <a href={elaboraTelefono} target="_blank" rel="noopener noreferrer">
                    Ver documento actual
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </Section>
      <div style={styles.bottomActionsRow}>
  <button
    onClick={handleGuardar}
    disabled={saving}
    style={{
      ...styles.btn,
      ...styles.btnSecondary,
      opacity: saving ? 0.7 : 1,
    }}
  >
    {saving ? "Guardando…" : "Guardar"}
  </button>

  <button
  onClick={handleDownloadWord}
  disabled={!isSaved || saving || loading}
  style={{
    ...styles.btn,
    ...styles.btnPrimary,
    opacity: !isSaved || saving || loading ? 0.6 : 1,
    cursor: !isSaved || saving || loading ? "not-allowed" : "pointer",
  }}
  title={!isSaved ? "Guarda la información antes de descargar" : "Descargar Word"}
>
  Descargar Word
</button>
</div>
    </div>
  </div>
  
)
}
// ================== COMPONENTES AUXILIARES ==================

function Section({ title, right, children }) {
  return (
    <section style={styles.section}>
      <div style={styles.sectionHeader}>
        <h2 style={styles.sectionTitle}>{title}</h2>
        {right && <div>{right}</div>}
      </div>
      <div style={styles.sectionBody}>{children}</div>
    </section>
  );
}

function InfoPill({ children, right }) {
  return (
    <div style={styles.infoPill}>
      <span>{children}</span>
      {right && <span style={styles.infoPillRight}>{right}</span>}
    </div>
  );
}

const numeroALetras = (valor) => {
  const n = Number(valor) || 0;
  return CURRENCY.format(n);
};

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f3f4f6",
    padding: 24,
  },
  topbar: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    marginBottom: 12,
  },
  topbarInner: {
    maxWidth: 1024,
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  h1: {
    fontSize: 18,
    fontWeight: 700,
    color: "#111827",
  },
  container: {
    maxWidth: 1024,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    paddingBottom: 32,
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: "1px solid #e5e7eb",
  },
  topActionsRow: {
    marginTop: 16,
    marginBottom: 8,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
  },
  bottomActionsRow: {
  marginTop: 16,
  display: "flex",
  justifyContent: "flex-end",
  gap: 8,
},
  actionsRight: {
    display: "flex",
    gap: 8,
  },
  btn: {
    borderRadius: 6,
    border: "1px solid transparent",
    padding: "6px 12px",
    fontSize: 14,
    cursor: "pointer",
    fontWeight: 500,
  },
  btnGhost: {
    backgroundColor: "#ffffff",
    borderColor: "#e5e7eb",
    color: "#374151",
  },
  btnSecondary: {
    backgroundColor: "#e5e7eb",
    color: "#111827",
  },
  btnPrimary: {
    backgroundColor: "#2563eb",
    color: "#ffffff",
  },
  section: {
    marginTop: 16,
    backgroundColor: "#ffffff",
    borderRadius: 8,
    padding: 16,
    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
    border: "1px solid #e5e7eb",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
    gap: 8,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#111827",
  },
  sectionBody: {
    marginTop: 8,
  },
  formRow: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    marginBottom: 12,
  },
  label: {
    fontSize: 14,
    fontWeight: 500,
    color: "#374151",
  },
  input: {
    width: "100%",
    padding: "6px 8px",
    fontSize: 14,
    borderRadius: 4,
    border: "1px solid #d1d5db",
    boxSizing: "border-box",
  },
  textarea: {
    width: "100%",
    padding: "6px 8px",
    fontSize: 14,
    borderRadius: 4,
    border: "1px solid #d1d5db",
    boxSizing: "border-box",
    resize: "vertical",
  },
  hint: {
    fontSize: 11,
    color: "#6b7280",
    marginTop: 2,
  },
  tableWrap: {
    width: "100%",
    overflowX: "auto",
    marginTop: 8,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 13,
  },
  th: {
    borderBottom: "1px solid #e5e7eb",
    padding: "8px 6px",
    textAlign: "left",
    backgroundColor: "#f9fafb",
    fontWeight: 600,
  },
  td: {
    borderBottom: "1px solid #e5e7eb",
    padding: "6px 6px",
    verticalAlign: "top",
  },
  tdRight: {
    borderBottom: "1px solid #e5e7eb",
    padding: "6px 6px",
    verticalAlign: "top",
    textAlign: "right",
  },
  btnOutline: {
    padding: "4px 8px",
    borderRadius: 4,
    border: "1px solid #d1d5db",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    fontSize: 12,
  },
  infoPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "4px 10px",
    borderRadius: 9999,
    backgroundColor: "#2563eb",
    color: "#ffffff",
    fontSize: 12,
  },
  infoPillRight: {
    opacity: 0.9,
    fontWeight: 500,
  },
};
